import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useMemo,
} from "react";
// import AdminHeading from "../Heading/AdminHeading";
import AdminHeading from "Components/Pages/AdminPanel/Heading/AdminHeading";
// import AdminBreadCrump from "../Heading/AdminBreadCrump";
import AdminBreadCrump from "Components/Pages/AdminPanel/Heading/AdminBreadCrump";
import { Icon } from "@iconify/react";
import "./AddBulkStock.css";
import style from "./AdminAddBulkStockNew.module.css";
import { useSelector } from "react-redux";

import { Link, useNavigate } from "react-router-dom";


import { GenerateLabel } from "Components/Other Functions/GenerateLabel";
// import GetApiService from "../../../Api/getapiService";
import GetApiService from "Components/Api/getapiService";
import { ClipLoader } from "react-spinners";
// import ErrorModal from "../../../Other Functions/popup";
import ErrorModal from "Components/Other Functions/popup";
import { FaPlus, FaTrash } from "react-icons/fa";
import { TableContainer } from "@mui/material";
import StonePopup from "Components/support/purchasesupport/StonePopup";

import { AddStockFields } from "./addstock";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import stockTemplate from "Components/support/addstock/stockTemplate";
import PayLoadService from "Components/Api/PayLoadServices";
import SingleStonePopUp from "Components/support/purchasesupport/SingleStonePopUp";
import SingleDiamondPopup from "Components/support/purchasesupport/SingleDiamondPopup";
import AddStockTopSection from "./AddStockTopSection";
import AddStockMiddleSection from "./AddStockMiddleSection";
import AddStockGridSection from "./AddStockGridSection";
import useStockTypeEffect from "./useStockTypeEffect";
import ProductFilter from "./ProductFilter";
import AddStockUtil from "./AddStockUtil";


// import { GenerateLabel } from "Components/Other Functions/GenerateLabel";

export default function AdminAddBulkStockNew() {
  const thStyle = {
    padding: "5px",
    border: "1px solid #ccc",
    textAlign: "center",
    fontWeight: "600",
  };

  const tdStyle = {
    padding: "5px",
    border: "1px solid #ccc",
    textAlign: "center",
  };

  const inputStyle = {
    width: "100%",
    padding: "3px",
    margin: "0",
    boxSizing: "border-box",
    borderRadius: "4px",
    border: "1px solid #ccc",
  };

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [category, setCategory] = useState("");
  const [baseMetal, setBaseMetal] = useState("");
  const [allLabelledStockData, setAllLabelledStockData] = useState([]);
  // const [addedProducts, setAddedProducts] = useState([]);
  const [parameter, setParameter] = useState("");
  const [formValue, setFormValue] = useState("");
  const [productType, setProductType] = useState("");
  const [boxType, setBoxType] = useState("");
  const [productInEdit, setProductInEdit] = useState([]);
  const [productInEditImages, setProductInEditImages] = useState();
  const [updatedProducts, setUpdatedProducts] = useState([]);
  const [showImportPopup, setShowImportPopup] = useState(false);
  const [importFile, setImportFile] = useState([]);

  const [loadingTop, setLoadingTop] = useState(true);

  const [allPurchaseItems, setAllPurchaseItems] = useState([]);
  const [allFilteredPurchaseItems, setAllFilteredPurchaseItems] = useState([]);
  const [allPacketNumbers, setAllPacketNumbers] = useState([]);
  // const [barcodeNumbersArray, setBarcodeNumbersArray] = useState([]);

  const [allSku, setAllSku] = useState([]);

  const [allSelectedSkuDiamonds, setAllSelectedSkuDiamonds] = useState([]);
  const [selectedSkuDiamonds, setSelectedSkuDiamonds] = useState([]);

  const navigate = useNavigate(); // Initialize navigate

  const [mainpieces, setmainpieces] = useState("");
  const [addStone, setAddStone] = useState({
    StoneName: "",
    StoneWeight: 0,
    StonePieces: 0,
    StoneRate: 0,
    StoneAmount: 0,
    Description: "",
    ClientCode: "",
    EmployeeCode: "",
    ProductId: 0,
  });
  const [addDiamond, setAddDiamond] = useState({
    DiamondName: "",
    DiamondWeight: 0,
    DiamondRate: 0,
    DiamondPieces: 0,
    DiamondClarity: "",
    DiamondColour: "",
    DiamondCut: "",
    DiamondShape: "",
    DiamondSize: 0,
    Certificate: "",
    SettingType: "",
    DiamondAmount: 0,
    DiamondPurchaseAmt: 0,
    Description: "",
  });

  const [popupData, setPopupData] = useState({
    isOpen: false,
    rowIndex: null,
    pieces: 0,
    initialRFIDs: [],
    initialTIDs: [],
  });

  //main data array

  const [productTypeData, setProductTypeData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [purityData, setPurityData] = useState([]);
  const [partyData, setPartyData] = useState([]);
  const [boxData, setBoxData] = useState([]);
  const [collectionTypeData, setCollectionTypeData] = useState([]);
  const [collectionmainlist, setCollectionmainlist] = useState([]);
  const [branchOption, setBranchOption] = useState([]);
  const [stonemaster, setStonemaster] = useState([]);
  const [rifdData, setRifdData] = useState([]);
  const [allDiamondSizeWeightRate, setAllDiamondSizeWeightRate] = useState([]);
  const [allDiamondAttributes, setAllDiamondAttributes] = useState([]);

  const [stockData, setStockData] = useState(stockTemplate);
  const [Supplier, setSupplier] = useState("");
  const [StockKeepingUnit, setSkuValue] = useState("");
  const [LotNumber, setLotnumber] = useState("");

  const [Branch, setBranch] = useState("");

  const [StockType, setStockType] = useState("Labelled");
  const [selectedcategory, setSelectedCategory] = useState('')
  const inputRefs = useRef([]);
  const [AddedProducts, setAddedProducts] = useState([]);
  const [popupVisible, setPopupVisible] = useState("close"); // To control popup visibility
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedsku, setSelectedsku] = useState([]);
  const [selectedWeights, setSelectedWeights] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const [columnIndex, setColumnIndex] = useState(null);
  const [topSectionEnabled, settopSectionEnabled] = useState(true);
  const [middleSectionEnabled, setmiddleSectionEnabled] = useState(true);
  const focusableRefs = useRef([]);

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);

  const submitButtonRef = useRef(null); // Ref for the Submit button

  const Submit = () => {
    console.log("submit is clicked");
  };

  // Focus inputRef1 on component mount
  // useEffect(() => {
  //   inputRef1.current?.focus();
  // }, []);

  // Handler function to move focus on Enter key press
  // const handleKeyPress = (e, nextInputRef) => {
  //   if (e.key === "Enter") {
  //     e.preventDefault(); // Prevent default form submission on Enter
  //     if (nextInputRef) {
  //       nextInputRef.current?.focus();
  //     } else {
  //       if (submitButtonRef.current) {
  //         submitButtonRef.current.click(); // Safely trigger click
  //       } else {
  //         console.error("Submit button ref is not available");
  //       }
  //     }
  //   }
  // };

  const handleKeyPress = (e, index) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent form submission
      const nextIndex = index + 1;
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus();
      }
    }
  };

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const employeedid = adminLoggedIn.EmployeeId;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);

  console.log("checking client code ", clientCode);

  const apiService = new GetApiService(clientCode);

  const loadData = async () => {
    setLoading(true);
    try {
      const apiCalls = [
        apiService.fetchAllCategories(),
        apiService.fetchAllBranches(),
        apiService.fetchAllProductType(),
        apiService.fetchAllPurities(),
        apiService.fetchAllCustomers(),
        apiService.fetchAllDesigns(),
        apiService.fetchAllBoxs(),
        apiService.fetchAllRdPurchaseItems(),
        apiService.fetchAllPacketNumbers(),
        apiService.fetchAllSku(),
        apiService.fetchAllDiamondSizeWeightRate(),
        apiService.fetchAllDiamondAttributes(),
        apiService.fetchAllLabelledStock(),
        apiService.fetchAllCollection(),
        apiService.fetchAllStonesList(),
        apiService.fetchAllRfid(),
        // apiService.fetchAllDiamondAttributes()
      ];

      const results = await Promise.allSettled(apiCalls);

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          // Handle successful response
          switch (index) {
            case 0:
              console.log("checking category ", result);
              if (Array.isArray(result.value)) {
                // Check if the first item's CategoryName is 'Gold'
                if (
                  result.value.length > 0 &&
                  result.value[0].CategoryName !== "GOLD"
                ) {
                  setCategoriesData(result.value.reverse());
                } else {
                  // Set data as-is (without reversing) if the first item is 'Gold'
                  setCategoriesData(result.value);
                }
              } else {
                setErrorMessage(
                  "Error: Unexpected response format for Categories."
                );
              }
              break;
            case 1:
              setBranchOption(result.value);
              if (result.value.length > 0) {
                setBranch(result.value[0].BranchName);
              }
              break;
            case 2:
              setProductTypeData(result.value);
              break;
            case 3:
              setPurityData(result.value);
              break;
            case 4:
              setPartyData(result.value);
              break;
            case 5:
              setCollectionTypeData(result.value);
              break;
            case 6:
              setBoxData(result.value);
              break;
            case 7:
              setAllPurchaseItems(result.value);
              setAllFilteredPurchaseItems(result.value);
              break;
            case 8:
              setAllPacketNumbers(result.value);
              break;
            case 9:
              setAllSku(result.value);
              break;
            case 10:
              setAllDiamondSizeWeightRate(result.value);
              break;
            case 11:
              setAllDiamondAttributes(result.value);
              console.log("check diamondattribute  ", result.value);
              break;
            case 12:
              setAllLabelledStockData(result.value);
              console.log("checking label  ", result.value);
              break;
            case 13:
              setCollectionmainlist(result.value);
              console.log("check allcollections ", result.value);
              break;
            case 14:
              setStonemaster(result.value);
              console.log("check allstones ", result.value);
              break;
            case 15:
              setRifdData(result.value);
              console.log("check allrfid  ", result.value);
              break;
            // case 16:

            //   console.log("check diamondattribute  ", result.value);
            //   break;
            default:
              break;
          }
        } else {
          if (index + 1 > 1) {
            console.error(
              `Error loading data for API ${index + 1}:`,
              result.reason
            );
            handleError(
              `Failed to load data for API ${index + 1}: ${result.reason}`
            );
          }
        }
      });
    } catch (error) {
      console.error("Error loading data:", error);
      handleError("Error loading data. Please try again later.", error);
    } finally {
      setLoading(false);
      setLoadingTop(false);
    }
  };

  useEffect(() => {
    if (adminLoggedIn && clientCode) {
      loadData();
    }
  }, [clientCode, adminLoggedIn]);

  // useEffect(() => {
  //   loadData();
  // }, [clientCode]);

  const apifields = useMemo(
    () =>
      adminLoggedIn.Modules.filter(
        (module) => module.PageName === "add_bulk_stock_new"
      ),
    [adminLoggedIn]
  );

  const localfields = useMemo(() => toPlainFields(AddStockFields), []);
  const apifieldsControls = useMemo(
    () => apifields[0]?.PageControls || [],
    [apifields]
  );

  console.log("check localfields  ", apifieldsControls);

  const [itemfields, setItemfields] = useState(() => {
    const updatedFields = localfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) =>
          apiField.key === localField.key && apiField.place === localField.place
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: localField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
          value: "",
        };
      }
      return localField;
    });

    console.log("check update fields ", updatedFields);

    return updatedFields;
  });

  // const [itemfields, setItemfields] = useState(() => {
  //   // Directly use localfields with default values for testing
  //   const updatedFields = localfields.map((localField) => ({
  //     ...localField,
  //     value: "", // Initialize value as empty string
  //     label: localField.label || "Default Label", // Use localField label or fallback
  //     placeholder: localField.placeholder || "Enter value", // Default placeholder
  //     priority: localField.priority || 1, // Default priority
  //     visibility: localField.place === 'top' || localField.place === 'middle' ? 'Hidden' : localField.visibility, // Default visibility for testing
  //     place: localField.place, // Default place
  //   }));

  //   console.log("Updated fields for testing:", updatedFields);

  //   return updatedFields;
  // });



  const [rerender, setRerender] = useState(0);

  useEffect(() => {
    // Determine if sections are enabled

    const topvisible = itemfields.some(
      (field) => field.place === "top" && field.visibility !== "Hidden"
    );

    const middlevisible = itemfields.some(
      (field) => field.place === "middle" && field.visibility !== "Hidden"
    );

    settopSectionEnabled(topvisible);

    setmiddleSectionEnabled(middlevisible);

    console.log("checking visible ", topvisible, "  ", middlevisible);

    if (!topvisible || !middlevisible) {
      handleadditem();
    }
  }, []);


  const getFieldValue = (key, place) => {
    const field = itemfields.find((f) => f.key === key && f.place === place);

    return field ? parseInt(field.value) : undefined; // Return the value or undefined if not found
  };

  const getFielddValue = (key) => {
    const field = itemfields.find((f) => f.key === key && f.place === "middle");
    return field && field.value ? parseInt(field.value, 10) : 0; // Ensure integer value or default to 0
  };

  const handleError = (message) => {
    setErrorMessage(message);
    setShowModal(true); // Open the modal
  };

  const reloadData = () => {
    setShowModal(false); // Close the modal
    loadData(); // Reload data
  };

  const [data, setData] = useState([
    {
      id: 1,
      vendor: "",
      itemCode: "",
      rfidCode: "",
      tidValue: "",
      totalWt: "",
      grossWt: "",
      stoneWt: "",
      clipWt: "",
      clipQty: "",
      netWt: "",
      tNetWt: "",
    },
  ]);

  const handleAddRow = () => {
    const newRow = {
      id: data.length + 1,
      vendor: "",
      itemCode: "",
      rfidCode: "",
      tidValue: "",
      totalWt: "",
      grossWt: "",
      stoneWt: "",
      clipWt: "",
      clipQty: "",
      netWt: "",
      tNetWt: "",
    };
    setData([...data, newRow]);
  };

  const [selectedImages2, setSelectedImages2] = useState([]); // modal imag select

  //new code

  const filterSuppliers = () => {
    if (LotNumber && LotNumber !== "0") {
      let filteredItems = allPurchaseItems.filter(
        (item) => item.LotNumber === LotNumber
      );

      // Filter `allPurchaseItems` based on `LotNumber`
      if (filteredItems.length > 0) {
        const vendorId = filteredItems[0].VendorId;

        // Filter `partyData` based on the VendorId
        const filteredSupplier = partyData.filter(
          (party) => party.Id === vendorId
        );

        // Return the filtered suppliers
        return filteredSupplier;
      }
    }
    console.log("check filtered supplier", StockKeepingUnit);

    if (StockKeepingUnit && StockKeepingUnit !== "") {
      // const lotlist = partyData.filter((item) => item.SKU === StockKeepingUnit)
      // console.log('check filtered items1', lotlist);

      // const filteredSkus = allSku.filter((sku) =>
      //   sku.SKUVendor.some((vendor) => vendor.VendorName === Supplier)
      // );

      const filteredsku = allSku.filter(
        (sku) => sku.Id === StockKeepingUnit
      );

      const skuvendorIds = filteredsku.flatMap((sku) =>
        sku.SKUVendor.map((vendor) => vendor.VendorId)
      );

      // Filter suppliers whose Id matches any VendorId in SKUVendor
      const filteredsupplier = partyData.filter((supplier) =>
        skuvendorIds.includes(supplier.Id)
      );

      console.log("Filtered suppliers:", filteredsupplier);

      return filteredsupplier;
    }

    return partyData;
  };

  // Example usage
  const filteredSupplier = filterSuppliers();

  const filterSku = () => {


    const sup = getFieldValue('VendorId', 'top')

    if (LotNumber && LotNumber !== "0") {
      // Filter `allPurchaseItems` based on `LotNumber`
      let filteredItems = allPurchaseItems.filter(
        (item) => item.LotNumber === LotNumber
      );
      if (filteredItems.length > 0) {
        const skuidList = filteredItems.map((item) => item.SKUId);

        // Filter allSku where `allSku.Id` matches any `filteredItem.SKUId`
        const filteredsku = allSku.filter((sku) => skuidList.includes(sku.Id));

        if (Supplier && Supplier !== "") {
          const filteredSkus = allSku.filter((sku) =>
            sku.SKUVendor.some((vendor) => vendor.VendorName === Supplier)
          );

          // Return the filtered SKUs
          return filteredSkus;
        }

        // Return the filtered SKUs
        return filteredsku;
      }
    }

    if (sup && sup !== "") {
      const filteredSkus = allSku.filter((sku) =>
        sku.SKUVendor.some((vendor) => vendor.VendorId === sup)
      );

      console.log('check filtersku ', allSku);

      // Return the filtered SKUs
      return filteredSkus;
    }

    return allSku;
  };

  const filteredsku = filterSku();

  const getUniqueLotNumbers = (items) => {
    if (!Array.isArray(items)) return [];
    const lotSet = new Set(); // Set to store unique lot numbers
    return items.filter((item) => {
      if (!lotSet.has(item.LotNumber)) {
        lotSet.add(item.LotNumber); // Add lot number to set if it's unique
        return true; // Keep this item in the filtered array
      }
      return false; // Ignore duplicate lot numbers
    });
  };

  const filterlot = () => {
    const uniqueLotNumbers = getUniqueLotNumbers(allFilteredPurchaseItems);
    const sup = getFieldValue('VendorId', 'top')
    console.log("check filtered items", StockKeepingUnit);
    if (
      Supplier &&
      Supplier !== "" &&
      StockKeepingUnit &&
      StockKeepingUnit !== ""
    ) {
      const lotlist = allFilteredPurchaseItems.filter(
        (item) =>
          item.VendorName === Supplier &&
          item.StockKeepingUnit === StockKeepingUnit
      );
      // console.log('check filtered items2', lotlist);
      return getUniqueLotNumbers(lotlist);
    }
    if (sup && sup !== "") {
      const lotlist = allFilteredPurchaseItems.filter(
        (item) => item.VendorId === sup
      );
      return getUniqueLotNumbers(lotlist);
    }
    if (StockKeepingUnit && StockKeepingUnit !== "") {
      const lotlist = allFilteredPurchaseItems.filter(
        (item) => item.StockKeepingUnit === StockKeepingUnit
      );
      console.log("check filtered items1", lotlist);
      return getUniqueLotNumbers(lotlist);
    }

    return allFilteredPurchaseItems;
  };

  const filteredlot = filterlot();

  useEffect(() => {
    if (!StockKeepingUnit || StockKeepingUnit === "") {
      resetFields();
      return;
    }

    const ssku = allSku.find(
      (sku) => sku.Id === StockKeepingUnit
    );

    // console.log("check selected sku ", StockKeepingUnit, '    ', allSku,'   ',ssku);

    if (ssku) {
      setSelectedsku(ssku);

      // Update itemfields based on the selected SKU
      setItemfields((prevFields) => {
        const updatedFields = prevFields.map((field) => {
          const key = field.key; // Ensure the `localfields` have a `key` property to match
          let newValue = ssku[key] || ""; // Get value from SKU or default to an empty string

          // if (key === 'CollectionId' && newValue>0) {

          //   newValue = ssku['CollectionId'] || "";
          //   const collection = collectionmainlist.find((item) => item.Collection.Id === newValue)

          //   newValue = collection.Collection.CollectionName;

          // }

          return {
            ...field,
            value: newValue, // Set the updated value from SKU or default to ""
          };
        });

        // Log the updated itemfields
        console.log("Updated itemfields:", updatedFields);
        console.log("check updated collection1 ", collectionmainlist);

        // Return the updated fields
        return updatedFields;
      });

      if (ssku.SKUStoneMain) {
        const updatedStonemaster = stonemaster.filter(
          (stone) => !stone.isFromSKU // Keep only non-SKU-specific stones
        );

        // Step 2: Map the new stones and mark them as SKU-specific
        const newStones = ssku.SKUStoneMain.map((stoneMain) => ({
          ...stoneMain,
          StoneName: stoneMain.StoneMainName,
          StoneWeight: stoneMain.StoneMainWeight,
          StonePieces: stoneMain.StoneMainPieces,
          StoneRatePiece: 0,
          StoneRateKarate: stoneMain.StoneMainRate,
          StoneRate: stoneMain.StoneMainRate,
          StoneAmount: stoneMain.StoneMainAmount,
          Description: stoneMain.StoneMainDescription,
          isFromSKU: true, // Mark new stones as SKU-specific
        }));

        // Step 3: Update the state
        setStonemaster([...updatedStonemaster, ...newStones]);
      }

      if (ssku.WeightCategories) {
        const parsedWeights = ssku.WeightCategories.split(",")
          .map(Number)
          .filter((num) => !isNaN(num));
        setSelectedWeights(parsedWeights);
        console.log("check filtered weights ", parsedWeights);
      }

      // setSelectedWeights
    }
  }, [StockKeepingUnit, allSku]);

  const resetFields = () => { };



  const handlemiddlerow = (e, key, place) => {
    const value = e.target.value;

    setItemfields((prevFields) => {
      const getFieldValue = (keyToFind) => {
        const field = prevFields.find(
          (f) => f.key === keyToFind && f.place === place
        );
        return parseFloat(field?.value || 0);
      };

      const updateField = (keyToUpdate, newValue) => {
        const fieldIndex = prevFields.findIndex(
          (f) => f.key === keyToUpdate && f.place === place
        );
        if (fieldIndex !== -1) {
          prevFields[fieldIndex] = {
            ...prevFields[fieldIndex],
            value: newValue,
          };
        }
      };

      const grossWt =
        key === "GrossWt" ? parseFloat(value || 0) : getFieldValue("GrossWt", 'middle');
      const stoneWt =
        key === "TotalStoneWeight"
          ? parseFloat(value || 0)
          : getFieldValue("TotalStoneWeight", 'middle');
      const packingWt =
        key === "PackingWeight"
          ? parseFloat(value || 0)
          : getFieldValue("PackingWeight", 'middle');
      const clipQty =
        key === "ClipQuantity"
          ? parseFloat(value || 0)
          : getFieldValue("ClipQuantity", 'middle');
      const clipWt =
        key === "ClipWeight"
          ? parseFloat(value || 0)
          : getFieldValue("ClipWeight", 'middle');
      const tweight =
        key === "TotalWeight"
          ? parseFloat(value || 0)
          : parseFloat(getFieldValue("TotalWeight", 'middle') || 0);
      const totalClipWt = clipQty * clipWt;

      if (
        [grossWt, stoneWt, packingWt, clipQty, clipWt].some((val) => isNaN(val))
      ) {
        alert("Error: Invalid input detected. Please provide numeric values.");
        return prevFields; // Skip updating if any value is invalid
      }

      updateField(key, value);

      // Update dependent fields
      if (key === "GrossWt") {
        const netWt = grossWt - stoneWt;
        const totalWeight = grossWt + packingWt;
        const tw = tweight > 0 ? totalWeight : 0;

        console.log("checking total ", totalWeight, "   ", tw);

        updateField("NetWt", netWt);
        updateField("TotalWeight", tw);
      } else if (key === "TotalStoneWeight") {
        const netWt = grossWt - stoneWt;
        updateField("NetWt", netWt);
      } else if (key === "PackingWeight") {
        console.log("checking packing weight ", packingWt, "   ", tweight);

        if (packingWt > tweight) {
          updateField("PackingWeight", 0);
        } else {
          if (packingWt > 0 && tweight > 0) {
            const g = tweight - packingWt;
            const n = g - stoneWt;

            updateField("GrossWt", g.toFixed(2));
            updateField("NetWt", n.toFixed(2));
          }
        }
      } else if (key === "ClipQuantity" || key === "ClipWeight") {
        const tpacking = totalClipWt;
        const tw = tpacking + grossWt;
        updateField("PackingWeight", totalClipWt);
        updateField("TotalWeight", tw);
      } else if (key === "TotalWeight") {
        if (tweight > 0) {
          const t = tweight - packingWt;
          const n = t - stoneWt;

          updateField("GrossWt", t);
          updateField("NetWt", n);
        } else {
          updateField("PackingWeight", 0);
          updateField("GrossWt", 0);
          updateField("NetWt", 0);
          updateField("TotalWeight", 0);
        }
      }

      return [...prevFields]; // Return the updated fields array
    });
  };





  const handleCreateAddedProducts = (e) => {
    e.preventDefault();
    const vendor = itemfields.find(
      (item) => item.key === "VendorId" && item.place === "top"
    );
    const branch = itemfields.find(
      (item) => item.key === "Branch" && item.place === "top"
    );


    console.log('checking vendor and branch ', vendor, '  ', branch);

    if (!vendor.value || !branch.value) {
      alert("Missing supplier or branch");
      return;
    }

    const parsedQuantity = parseInt(getFieldValue("Quantity", 'middle'));

    if (isNaN(parsedQuantity) || parsedQuantity < 1) {
      alert("Error: Quantity must be at least 1 and cannot be empty or null.");
      return; // Stop the process
    }
    const design = getFieldValue("DesignId", 'middle')
    const itemCode = AddStockUtil.generateItemCode({
      designId: design,
      AddedProducts: AddedProducts,
      allLabelledStockData: allLabelledStockData,
      collectionTypeData: collectionTypeData,
      from: "middle",
    });
    let createProduct = {};

    const bid = branchOption.find((b) => b.BranchName === Branch);
    const vid = filteredSupplier.find((v) => v.Id === getFieldValue("VendorId", 'top'));
    const sid =
      filteredsku.find((v) => v.Id === StockKeepingUnit) || {};

    const catid =
      categoriesData.find((v) => v.Id === getFieldValue("CategoryId", 'middle')) || {};
    // const catid = categoriesData.find((v) => v.Id === 1) || {};

    if (catid.CategoryName.toUpperCase().includes("LOOSE DIAMOND")) {

    } else if (
      catid.CategoryName.toUpperCase().includes("GOLD") ||
      catid.CategoryName.toUpperCase().includes("SILVER") ||
      catid.CategoryName.toUpperCase().includes("PLATINUM")
    ) {
      const proid =
        filteredProducts("middle").find(
          (v) => v.Id === getFieldValue("ProductId", 'middle')
        ) || {};
      const puid =
        filteredPurity("middle").find(
          (v) => v.Id === getFieldValue("PurityId", 'middle')
        ) || {};
      const did =
        filteredDesigns("middle").find(
          (d) => d.Id === getFieldValue("DesignId", 'middle')
        ) || {};
      const cid =
        collectionmainlist?.find(
          (c) => c.Collection.Id === getFieldValue("CollectionId", 'middle')
        ) || {};
      const pid =
        allPacketNumbers.find((c) => c.Id === getFieldValue("PacketId", 'middle')) || {};
      const boxid = boxData.find((c) => c.Id === getFieldValue("BoxId", 'middle')) || {};


      if (!catid.Id || !proid.Id || !puid.Id || !did.Id) {
        alert("Category, product, Design, Purity one of the value empty");
        return;
      }

      const mainstoneValue = getFieldValue("mainstone", 'middle');
      const mainstoneId = mainstoneValue ? parseInt(mainstoneValue, 10) : null; // Parse only if value exists
      const stoneid = mainstoneId
        ? selectedsku?.SKUStoneMain?.filter((c) => c.Id === mainstoneId) || []
        : []; // Default to empty array if no valid ID
      console.log('checking filteredsupplieradd ', filteredSupplier
      );
      console.log("check middle sku ", selectedsku);
      console.log("check mainstoneValue ", collectionmainlist);
      console.log("check mainstoneId ", getFieldValue("VendorId", 'top'));
      console.log("check middle stoneid ", cid);

      const mstone = stoneid?.map((stoneMain) => ({
        ...stoneMain,
        StoneName: stoneMain.StoneMainName,
        StoneWeight: stoneMain.StoneMainWeight,
        StonePieces: stoneMain.StoneMainPieces,
        StoneRatePiece: 0,
        StoneRateKarate: stoneMain.StoneMainRate,
        StoneAmount: stoneMain.StoneMainAmount,
        Description: stoneMain.StoneMainDescription,
      }));

      // const totalstoneweight = mstone.reduce(
      //   (total, stone) => total + (parseFloat(stone.StoneWeight) || 0),
      //   0
      // );

      const calculatedStoneWeight = mstone.reduce(
        (total, stone) => total + (parseFloat(stone.StoneWeight) || 0),
        0
    );
    const userProvidedStoneWeight = parseFloat(getFieldValue("TotalStoneWeight", "middle")) || 0;

    const totalstoneweight = userProvidedStoneWeight > 0 
        ? userProvidedStoneWeight 
        : calculatedStoneWeight;
      const totalstoneamount = mstone.reduce(
        (total, stone) => total + (parseFloat(stone.StoneAmount) || 0),
        0
      );
      const totalstonepieces = mstone.reduce(
        (total, stone) => total + (parseFloat(stone.StonePieces) || 0),
        0
      );

      console.log("check middle item ", itemfields);

      const totalwt =
        getFielddValue("GrossWt") + getFielddValue("PackingWeight");
      const nwt = getFielddValue("GrossWt") - totalstoneweight;

      setItemfields((prevFields) =>
        prevFields.map((field) => {
          if (field.key === "TotalWeight") {
            return {
              ...field,
              visibility: "ReadWrite",
            };
          } else if (field.key === "TotalStoneWeight") {
            return {
              ...field,
              visibility: mstone.length > 0 ? "ReadOnly" : "ReadWrite",
            };
          } else if (field.key === "NetWt") {
            return {
              ...field,
              visibility: "ReadOnly",
            };
          } else if (field.key === "TIDNumber") {
            return {
              ...field,
              visibility: "ReadOnly",
            };
          }
          // else if(){

          // }
          return field;
        })
      );
      // Map over itemfields to construct the object dynamically
      itemfields.forEach((item) => {
        if (item.key && item.place === "middle") {
          createProduct[item.key] = item.value || ""; // Assign key-value pairs dynamically
        }
      });
      const productList = Array.from(
        { length: createProduct.Quantity },
        (_, i) => {
          const newNumber = itemCode.number + i + 1;
          const newItemCode = `${itemCode.prefix}${newNumber}`;
          return {
            ...createProduct,
            Quantity: "1",
            ItemCode: newItemCode,
            BranchName: Branch,
            BranchId: bid?.Id || "", // Default to an empty string if undefined
            VendorName: vid?.VendorName,
            VendorId: vid?.Id || "",
            SKU: sid?.StockKeepingUnit || "", // Keep SKU empty if not provided
            SKUId: sid?.Id || "", // Keep SKUId empty if not found

            CategoryName: catid?.CategoryName,
            ProductName: proid?.ProductName,
            PurityName: puid?.PurityName || "",

            DesignId: did?.Id || "",
            DesignName: did?.DesignName || "",
            CollectionId: cid?.Collection?.Id || "",
            CollectionNameSKU: cid?.Collection?.CollectionName || "",
            PacketId: pid?.Id || "",
            PacketName: pid?.PacketName || "",
            BoxId: boxid?.Id || "",
            BoxName: boxid?.BoxName || "",
            Stones: mstone || [],
            WeightCategory: getFieldValue("WeightCategory", 'middle'),
            LotNumber: LotNumber || 0,
            TotalStoneWeight: totalstoneweight ,
            TotalStoneAmount: totalstoneamount || 0,
            TotalStonePieces: totalstonepieces || 0,
            TotalWeight: totalwt || 0,
            NetWt: nwt,
          };
        }
      );
      console.log("check item", createProduct);
      console.log("check item11", productList);

      setAddedProducts(productList);

      setItemfields((prevFields) =>
        prevFields.map((field) => {
          return {
            ...field,
            value: "",
          };
        })
      );
    }
  };



  const handleGridchange = (e, index, key) => {
    // const value = parseFloat(e.target.value); // Ensure the value is a valid number

    console.log("checking keys", key);

    const value = e.target.value;
    setAddedProducts((prevProducts) =>
      prevProducts.map((row, rowIndex) => {
        if (rowIndex !== index) return row;

        let updatedRow = { ...row, [key]: value };
        console.log("check totalwt ", key);

        if (
          [
            "GrossWt",
            "TotalStoneWeight",
            "PackingWeight",
            "ClipQuantity",
            "ClipWeight",
            "PackingWeight",
            "OtherWeight",
            "PouchWeight",
            "TagWeight",
            "FindingWeight",
            "LanyardWeight",
            "TotalWeight",
          ].includes(key)
        ) {
          const grossWt =
            key === "GrossWt"
              ? parseFloat(value)
              : parseFloat(row.GrossWt || 0);
          const stoneWt =
            key === "TotalStoneWeight"
              ? parseFloat(value)
              : parseFloat(row.TotalStoneWeight || 0);
          const packingWt =
            key === "PackingWeight"
              ? parseFloat(value)
              : parseFloat(row.PackingWeight || 0);
          const clipQty =
            key === "ClipQuantity"
              ? parseFloat(value)
              : parseFloat(row.ClipQuantity || 1);
          const clipWt =
            key === "ClipWeight"
              ? parseFloat(value)
              : parseFloat(row.ClipWeight || 0);
          const tweight =
            key === "TotalWeight"
              ? parseFloat(value)
              : parseFloat(row.TotalWeight || 0);
          const otherweight =
            key === "OtherWeight"
              ? parseFloat(value)
              : parseFloat(row.OtherWeight || 0);
          const pouchweight =
            key === "PouchWeight"
              ? parseFloat(value)
              : parseFloat(row.PouchWeight || 0);
          const tagweight =
            key === "TagWeight"
              ? parseFloat(value)
              : parseFloat(row.TagWeight || 0);
          const findweight =
            key === "FindingWeight"
              ? parseFloat(value)
              : parseFloat(row.FindingWeight || 0);
          const lanyweight =
            key === "LanyardWeight"
              ? parseFloat(value)
              : parseFloat(row.LanyardWeight || 0);

          if (
            [
              grossWt,
              stoneWt,
              packingWt,
              clipQty,
              clipWt,
              otherweight,
              pouchweight,
              tagweight,
              findweight,
            ].some((val) => isNaN(val))
          ) {
            alert(
              "Error: Invalid input detected. Please provide numeric values."
            );
            return row; // Skip updating this row if the input is invalid
          }

          const totalClipWt = clipQty * clipWt;
          // if (clipWt + stoneWt >= grossWt || stoneWt >= grossWt || clipWt >= grossWt) {
          //   alert("Error: Stone weight and clip weight combined, or individually, cannot exceed gross weight.");
          //   return row; // Skip updating this row if the condition fails
          // }

          // // Calculate NetWt and TotalWeight
          // const netWt = grossWt - stoneWt - packingWt;
          // const totalWeight = grossWt + packingWt + totalClipWt;

          // const tpacking1 = totalClipWt+otherweight+pouchweight+tagweight+findweight;

          // console.log('cheking packing wt ',tpacking1 );

          if (key === "GrossWt") {
            // if (tweight > 0 ) {
            //   if (grossWt > tweight) {
            //     alert("Error: Gross weight cannot exceed the total weight.");
            //     return row;
            //   }
            // }
            // const tpacking = ;

            const n = grossWt - stoneWt;
            const tw = grossWt + packingWt;
            updatedRow = {
              ...updatedRow,
              // GrossWt: g.toFixed(2),
              NetWt: n.toFixed(2),
              TotalWeight: tweight > 0 ? tw : 0,
            };
          } else if (key === "TotalStoneWeight") {
            const n = grossWt - stoneWt;
            updatedRow = {
              ...updatedRow,
              // GrossWt: g.toFixed(2),
              NetWt: n.toFixed(2),
            };
          } else if (key === "PackingWeight") {
            if (packingWt > tweight) {
              updatedRow = {
                ...updatedRow,
                PackingWeight: 0, // Reset PackingWeight
              };

              // Replace alert with a user-friendly notification
              alert("Packing weight cannot be more than the total weight."); // Hypothetical function for showing errors

              console.error(
                "Invalid PackingWeight: Packing weight exceeds total weight."
              );

              // return; // Stop further execution
            } else {
              if (packingWt > 0 && tweight > 0) {
                const g = tweight - packingWt;
                const n = g - stoneWt;
                updatedRow = {
                  ...updatedRow,
                  GrossWt: g.toFixed(2),
                  NetWt: n.toFixed(2),
                };

                // handleVisibilityChange(key)
                handleVisibilityChange(key, "ReadOnly");
              }
              // else if (packingWt > 0) {
              //   const t = grossWt + packingWt;
              //   // const n = g - stoneWt;
              //   updatedRow = {
              //     ...updatedRow,
              //     // PackingWeight: 0,
              //     TotalWeight:t
              //   };
              //   handleVisibilityChange(key, 'ReadOnly')
              // }

              // else {
              //   updatedRow = {
              //     ...updatedRow,
              //     PackingWeight: 0
              //   };

              // }
            }
          } else if (key === "ClipQuantity") {
            // if(totalClipWt > 0){

            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;

            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");

            // }
          } else if (key === "ClipWeight") {
            if (totalClipWt > 0) {
              // handleVisibilityChange(key)
              const tpacking =
                totalClipWt +
                otherweight +
                pouchweight +
                tagweight +
                findweight +
                lanyweight;
              const tw = tpacking + grossWt;
              // handleVisibilityChange(key)
              updatedRow = {
                ...updatedRow,
                PackingWeight: tpacking,
                TotalWeight: tw,
              };
              handleVisibilityChange(key, "ReadOnly");
            }
          } else if (key === "TotalWeight") {
            if (tweight > 0) {
              const t = tweight - packingWt;
              const n = t - stoneWt;

              // const n = g - stoneWt;
              updatedRow = {
                ...updatedRow,
                // PackingWeight: 0,
                GrossWt: t,
                NetWt: n,
              };
            } else {
              updatedRow = {
                ...updatedRow,
                PackingWeight: 0,
                GrossWt: 0,
                NetWt: 0,
                TotalWeight: 0,
              };
            }

            // handleVisibilityChange(key, 'ReadOnly')
          } else if (key === "OtherWeight") {
            // if(otherweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else if (key === "PouchWeight") {
            // if(pouchweight > 0){
            console.log("checking packing weight  ", pouchweight);

            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }else{

            // }
          } else if (key === "TagWeight") {
            // if(tagweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else if (key === "FindingWeight") {
            // if(findweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else if (key === "LanyardWeight") {
            // if(lanyweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else {
          }

          // if (tweight > 0) {
          //   if (grossWt > tweight) {
          //     alert("Error: Gross weight cannot exceed the total weight.");
          //     return row;
          //   }
          // }

          // if (packingWt > tweight) {
          //   alert("Error: Packing weight cannot exceed the total weight.");
          //   return row;
          // }
          // if (stoneWt > grossWt) {
          //   alert("Error: Stone weight cannot exceed the gross weight.");
          //   return row;
          // }
          // if (totalClipWt > grossWt) {
          //   alert("Error: Clip weight cannot exceed the gross weight.");
          //   return row;
          // }

          // // Calculate NetWt and TotalWeight
          // const totalWeight = grossWt + packingWt + totalClipWt;
          // // const netWt = grossWt - stoneWt;
          // const gross = tweight - packingWt;
          // const netWt = gross - stoneWt;
          // let packing = 0;
          // if (tweight > 0) {
          //   packing = tweight - grossWt;
          // }

          // if (netWt > grossWt) {
          //   alert("Error: Net weight cannot exceed the total weight.");
          //   return row;
          // }

          // if (key === 'PackingWeight') {
          //   updatedRow = {
          //     ...updatedRow,
          //     NetWt: netWt.toFixed(2),
          //     GrossWt: gross.toFixed(2),
          //     // PackingWeight:packing.toFixed(2)
          //     // TotalWeight: totalWeight.toFixed(2),
          //   };
          // } else
          //   if (key === 'GrossWt') {
          //     updatedRow = {
          //       ...updatedRow,
          //       NetWt: netWt.toFixed(2),
          //       // GrossWt:gross.toFixed(2),
          //       PackingWeight: packing.toFixed(2)
          //       // TotalWeight: totalWeight.toFixed(2),
          //     };
          //   } else {
          //     updatedRow = {
          //       ...updatedRow,
          //       NetWt: netWt.toFixed(2),
          //       // GrossWt:gross.toFixed(2),
          //       // PackingWeight:packing.toFixed(2)
          //       // TotalWeight: totalWeight.toFixed(2),
          //     };
          //   }
        }

        // if (key === "RFIDCode") {
        //   const barcodeValue = value.toUpperCase();
        //   updatedRow.RFIDCode = barcodeValue;

        //   const isBarcodeInUse = allLabelledStockData.some(
        //     (item) => item.RFIDCode === barcodeValue && item.Status !== "Sold"
        //   );

        //   if (isBarcodeInUse) {
        //     alert(`Barcode ${barcodeValue} is already in use for another product.`);
        //     updatedRow.RFIDCode = ""; // Clear RFIDCode if duplicate
        //   } else {
        //     const matchingProduct = rifdData?.find(
        //       (item) => item.BarcodeNumber === barcodeValue
        //     );
        //     updatedRow.TIDNumber = matchingProduct ? matchingProduct.TidValue : null;
        //   }
        // }

        // if (key === "RFIDCode") {
        //   const enteredBarcodes = value
        //     .toUpperCase()
        //     .split(",")
        //     .map((code) => code.trim()) // Trim whitespace
        //     .filter(Boolean); // Remove empty values

        //   const validBarcodes = [];
        //   const tidNumbers = [];
        //   const invalidBarcodes = [];

        //   enteredBarcodes.forEach((barcode) => {
        //     const isBarcodeInUse = allLabelledStockData.some(
        //       (item) => item.RFIDCode === barcode && item.Status !== "Sold"
        //     );

        //     if (isBarcodeInUse) {
        //       alert(`Barcode ${barcode} is already in use.`);
        //       invalidBarcodes.push(barcode); // Track invalid barcodes
        //     } else {
        //       const matchingProduct = rifdData?.find(
        //         (item) => item.BarcodeNumber === barcode
        //       );

        //       if (matchingProduct) {
        //         validBarcodes.push(barcode);
        //         tidNumbers.push(matchingProduct.TidValue);
        //       } else {
        //         alert(`Barcode ${barcode} is not valid or does not exist.`);
        //         invalidBarcodes.push(barcode); // Track invalid barcodes
        //       }
        //     }
        //   });

        //   // Filter out invalid barcodes from the input
        //   const filteredInput = enteredBarcodes.filter(
        //     (barcode) => !invalidBarcodes.includes(barcode)
        //   );

        //   if (itemPieces === 1 && filteredInput.length > 1) {
        //     alert("Only one barcode is allowed for a single item piece.");
        //     updatedRow.RFIDCode = filteredInput[0] || "";
        //     updatedRow.TIDNumber = tidNumbers[0] || null;
        //   } else {
        //     updatedRow.RFIDCode = filteredInput.join(",");
        //     updatedRow.TIDNumber = tidNumbers.join(",");
        //   }
        // }

        if (key === "RFIDCode") {
          const barcodeValue = value.toUpperCase();
          updatedRow.RFIDCode = barcodeValue;

          const isBarcodeInUse = allLabelledStockData.some(
            (item) => item.RFIDCode === barcodeValue && item.Status !== "Sold"
          );

          if (isBarcodeInUse) {
            alert(
              `Barcode ${barcodeValue} is already in use for another product.`
            );
            updatedRow.RFIDCode = ""; // Clear RFIDCode if duplicate
          } else {
            const matchingProduct = rifdData?.find(
              (item) => item.BarcodeNumber === barcodeValue
            );
            updatedRow.TIDNumber = matchingProduct
              ? matchingProduct.TidValue
              : null;
          }
        }

        // if (key === "RFIDCode") {
        //   const enteredValue = value.toUpperCase();
        //   const itemPieces = updatedRow.Pieces || 1

        //   if(itemPieces === 1){

        //   }else{

        //   }

        //   const barcodeParts = enteredValue.split(",").map((code) => code.trim());
        //   const lastBarcode = barcodeParts[barcodeParts.length - 1];

        //   // Limit barcodes to the number of pieces
        //   if (barcodeParts.length > itemPieces) {
        //     alert(`You can only enter up to ${itemPieces} barcodes.`);
        //     updatedRow.RFIDCode = barcodeParts.slice(0, itemPieces).join(",");
        //     return updatedRow; // Stop further processing
        //   }

        //   // Validate each barcode
        //   const validBarcodes = [];
        //   const tidNumbers = [];

        //   for (let i = 0; i < barcodeParts.length; i++) {
        //     const barcode = barcodeParts[i];

        //     if (barcode) {
        //       const isBarcodeInUse = allLabelledStockData.some(
        //         (item) => item.RFIDCode === barcode && item.Status !== "Sold"
        //       );

        //       if (isBarcodeInUse) {
        //         updatedRow.RFIDCode = lastBarcode;
        //         // alert(`Barcode ${barcode} is already in use.`);

        //         continue; // Skip invalid barcode
        //       }

        //       const matchingProduct = rifdData?.find(
        //         (item) => item.BarcodeNumber === barcode
        //       );

        //       if (matchingProduct) {
        //         validBarcodes.push(barcode);
        //         tidNumbers.push(matchingProduct.TidValue);
        //       } else {
        //         updatedRow.RFIDCode = lastBarcode;
        //         // alert(`Barcode ${barcode} is not valid.`);
        //       }
        //     }
        //   }

        //   updatedRow.RFIDCode = validBarcodes.join(",");
        //   updatedRow.TIDNumber = tidNumbers.join(",");
        // }

        if (["MakingPercentage", "WastagePercent"].includes(key)) {
          updatedRow.MakingPercentage = value;
          updatedRow.WastagePercent = value;
        }

        return updatedRow;
      })
    );
  };

  const handleRFIDFocus = (index, pieces, rfidCode, tidValue) => {
    const initialRFIDs = rfidCode ? rfidCode.split(",") : [];
    const initialTIDs = tidValue ? tidValue.split(",") : [];
    setPopupData({
      isOpen: true,
      rowIndex: index,
      pieces,
      initialRFIDs,
      initialTIDs,
    });
  };

  const handlePopupSave = (rfidCode, tidValue) => {
    setAddedProducts((prevProducts) =>
      prevProducts.map((row, rowIndex) => {
        if (rowIndex !== popupData.rowIndex) return row;
        return { ...row, RFIDCode: rfidCode, TIDNumber: tidValue };
      })
    );
    setPopupData({ ...popupData, isOpen: false });
  };

  const handleVisibilityChange = (key, visible) => {
    if (key === "PackingWeight") {
      setItemfields((prevFields) =>
        prevFields.map((field) => {
          if (
            [
              "ClipQuantity",
              "ClipWeight",
              "OtherWeight",
              "PouchWeight",
              "TagWeight",
              "FindingWeight",
            ].includes(field.key) &&
            field.place === "grid"
          ) {
            return {
              ...field,
              visibility: visible, // Ensure other fields in the grid remain editable
            };
          }
          return field;
        })
      );
    } else if (
      [
        "ClipQuantity",
        "ClipWeight",
        "OtherWeight",
        "PouchWeight",
        "TagWeight",
        "FindingWeight",
      ].includes(key)
    ) {
      setItemfields((prevFields) =>
        prevFields.map((field) => {
          if (field.key === "PackingWeight" && field.place === "grid") {
            return {
              ...field,
              visibility: visible, // Ensure PackingWeight remains editable in the grid
            };
          }
          return field;
        })
      );
    }
  };

  const handlegridonchange = (e, index, key) => {
    const inputValue = e.target.value.trim();

    setAddedProducts((prevProducts) =>
      prevProducts.map((row, rowIndex) => {
        if (rowIndex !== index) return row;

        // let updatedRow = { ...row, [key]: inputValue };
        let updatedRow = { ...row };
        if (key === "VendorId") {
          updatedRow["VendorName"] = inputValue;
        } else {
          updatedRow[key] = inputValue;
        }

        if (inputValue !== "") {
          if (key === "SKU") {
            const matchedSku = allSku.find(
              (sku) => sku.StockKeepingUnit === inputValue
            );
            if (matchedSku) {
              console.log("Checking matched SKU: ", matchedSku);
              itemfields.forEach((item) => {
                if (item.key && item.place === "middle") {
                  updatedRow[item.key] = matchedSku[item.key] || ""; // Dynamically update based on match
                }
              });
            }
          }

          if (key === "VendorId") {
            const matchedVendor = partyData.find(
              (vendor) => vendor.VendorName === inputValue
            );
            if (matchedVendor) {
              console.log("Checking matched Vendor: ", matchedVendor);
              updatedRow["VendorName"] = matchedVendor.VendorName;
              updatedRow["VendorId"] = matchedVendor.Id;
            }
          }
        }
        console.log("checking updaterow ", updatedRow, "   ", key);
        return updatedRow;
      })
    );
  };

  const validateInputGrid = (e, index, key) => {
    const inputValue = e.target.value.trim();

    setAddedProducts((prevProducts) =>
      prevProducts.map((row, rowIndex) => {
        if (rowIndex !== index) return row; // Skip rows that are not updated

        let updatedRow = { ...row, [key]: inputValue }; // Update the field with the input value

        if (inputValue !== "") {
          console.log("checking keyvalue ", key, "  ", inputValue);

          if (key === "SKU") {
            // Check if SKU exists in allSku
            const matchedSku = allSku.find(
              (sku) => sku.StockKeepingUnit === inputValue
            );
            if (!matchedSku) {
              // Invalid SKU, reset the field in state
              alert("Invalid SKU selected!");
              updatedRow[key] = ""; // Reset the field in state
              itemfields.forEach((item) => {
                if (item.key && item.place === "middle") {
                  updatedRow[item.key] = ""; // Assign key-value pairs dynamically
                }
              });

              updatedRow = {
                ...updatedRow,
                Quantity: "1",
                ItemCode: "",
                BranchName: "",
                BranchId: "",
                SKU: "",
                SKUId: "",

                CategoryId: "",
                CategoryName: "",

                DesignName: "",

                PurityId: "",
                PurityName: "test",

                CollectionId: "",
                CollectionNameSKU: "",

                PacketId: "",
                PacketName: "",

                BoxId: "",
                BoxName: "",

                Stones: [],
                WeightCategory: "",
                LotNumber: 0,
                TotalStoneWeight: 0,
                TotalStoneAmount: 0,
                TotalStonePieces: 0,
                TotalWeight: 0,
                NetWt: 0,
              };
              setItemfields((prevFields) =>
                prevFields.map((field) => {
                  if (
                    [
                      "CategoryId",
                      "ProductId",
                      "PurityId",
                      "DesignId",
                    ].includes(field.key) &&
                    field.place === "grid" &&
                    field.visibility !== "Hidden"
                  ) {
                    return {
                      ...field,
                      visibility: "ReadWrite", // Ensure other fields in the grid remain editable
                    };
                  }
                  return field;
                })
              );
            } else {
              console.log("Checking matched ", matchedSku);
              itemfields.forEach((item) => {
                if (item.key && item.place === "middle") {
                  updatedRow[item.key] = matchedSku[item.key] || ""; // Assign key-value pairs dynamically
                }
              });

              const bid = branchOption.find((b) => b.BranchName === Branch);

              const vid = filteredSupplier.find(
                (v) => v.VendorName === updatedRow["VendorName"]
              );
              const sid =
                filteredsku.find(
                  (v) => v.StockKeepingUnit === updatedRow["SKU"]
                ) || {};
              const catid =
                categoriesData.find((v) => v.Id === updatedRow["CategoryId"]) ||
                {};
              // const porductid = filteredProducts.find((d) => d.Id === updatedRow['ProductId']) || {};
              // const did = filteredDesigns.find((d) => d.Id === updatedRow['DesignId']) || {};
              // const purityid = filteredPurity.find((d) => d.Id === updatedRow['PurityId']) || {};
              const cid =
                collectionmainlist.find(
                  (c) => c.Id === updatedRow["CollectionId"]
                ) || {};
              const pid =
                allPacketNumbers.find((c) => c.Id === updatedRow["PacketId"]) ||
                {};
              const boxid =
                boxData.find((c) => c.Id === updatedRow["BoxId"]) || {};

              updatedRow["ItemCode"] = "";
              const number = generateitemcode({
                designId: matchedSku.DesignId,
                AddedProducts: [
                  ...prevProducts.map((p, i) => (i === index ? updatedRow : p)), // Include the updated row in AddedProducts
                ],
                allLabelledStockData,
                from: "grid",
              });

              console.log("check itemcode generate ", number);

              updatedRow = {
                ...updatedRow,
                Quantity: "1",
                ItemCode: number,
                BranchName: Branch,
                BranchId: bid?.Id || "",
                VendorName: vid?.VendorName || "",
                VendorId: vid?.Id || "",
                SKU: matchedSku.StockKeepingUnit || "",
                SKUId: sid?.Id || "",

                CategoryId: updatedRow["CategoryId"],
                CategoryName: catid.CategoryName,

                // ProductId:
                // ProductName:

                DesignName: matchedSku?.DesignName || "",

                PurityId: matchedSku?.PurityId || "",
                PurityName: matchedSku?.PurityName || "",

                CollectionId: cid?.Id || "",
                CollectionNameSKU: cid?.Collection?.CollectionName || "",

                PacketId: pid?.Id || "",
                PacketName: pid?.PacketName || "",

                BoxId: boxid?.Id || "",
                BoxName: boxid?.BoxName || "",

                Stones: updatedRow["Stones"] || [],
                WeightCategory: getFieldValue("WeightCategory", 'middle'),
                LotNumber: updatedRow["LotNumber"] || 0,
                TotalStoneWeight: updatedRow["TotalStoneWeight"] || 0,
                TotalStoneAmount: updatedRow["TotalStoneAmount"] || 0,
                TotalStonePieces: updatedRow["TotalStonePieces"] || 0,
                TotalWeight: updatedRow["TotalWeight"] || 0,
                NetWt: updatedRow["NetWt"] || 0,
              };

              setItemfields((prevFields) =>
                prevFields.map((field) => {
                  if (
                    [
                      "CategoryId",
                      "ProductId",
                      "PurityId",
                      "DesignId",
                    ].includes(field.key) &&
                    field.place === "grid" &&
                    field.visibility !== "Hidden"
                  ) {
                    return {
                      ...field,
                      visibility: "ReadOnly", // Ensure other fields in the grid remain editable
                    };
                  }
                  return field;
                })
              );

              console.log("check updated row", updatedRow);
            }
          } else if (key === "VendorId") {
            const matchedSku = partyData.find(
              (item) => item.VendorName === inputValue
            );
            if (!matchedSku) {
              // Invalid SKU, reset the field in state
              alert("Invalid supplier selected!");
              updatedRow[key] = ""; // Reset the field in state
            } else {
              console.log("Checking matched 1", matchedSku);
              updatedRow["VendorName"] = matchedSku.VendorName;
              updatedRow["VendorId"] = matchedSku.Id;
            }
          }
        } else {
          if (key === "SKU") {
            updatedRow[key] = ""; // Reset the field in state
            itemfields.forEach((item) => {
              if (item.key && item.place === "middle") {
                updatedRow[item.key] = ""; // Assign key-value pairs dynamically
              }
            });

            updatedRow = {
              ...updatedRow,
              Quantity: "1",
              ItemCode: "",
              BranchName: "",
              BranchId: "",
              SKU: "",
              SKUId: "",

              CategoryId: "",
              CategoryName: "",

              DesignName: "",

              PurityId: "",
              PurityName: "test",

              CollectionId: "",
              CollectionNameSKU: "",

              PacketId: "",
              PacketName: "",

              BoxId: "",
              BoxName: "",

              Stones: [],
              WeightCategory: "",
              LotNumber: 0,
              TotalStoneWeight: 0,
              TotalStoneAmount: 0,
              TotalStonePieces: 0,
              TotalWeight: 0,
              NetWt: 0,
            };
            setItemfields((prevFields) =>
              prevFields.map((field) => {
                if (
                  ["CategoryId", "ProductId", "PurityId", "DesignId"].includes(
                    field.key
                  ) &&
                  field.place === "grid" &&
                  field.visibility !== "Hidden"
                ) {
                  return {
                    ...field,
                    visibility: "ReadWrite", // Ensure other fields in the grid remain editable
                  };
                }
                return field;
              })
            );
          }
        }
        console.log("check updated row", updatedRow);
        return updatedRow;
      })
    );
  };

  function findClosestWeightCategory(grossWt, weightCategoriesArray) {
    // Sort weight categories in ascending order
    weightCategoriesArray.sort((a, b) => a - b);

    // Initialize closest category with the first element
    let closestCategory = weightCategoriesArray[0];

    // Loop through each category to find the closest
    for (let i = 0; i < weightCategoriesArray.length; i++) {
      let currentCategory = weightCategoriesArray[i];

      // If the grossWt is less than or equal to the current category, assign it
      if (grossWt <= currentCategory) {
        closestCategory = currentCategory;
        break;
      }

      // If the grossWt is slightly higher, find the closest match based on distance
      if (grossWt > currentCategory) {
        if (i < weightCategoriesArray.length - 1) {
          const nextCategory = weightCategoriesArray[i + 1];

          if (grossWt <= nextCategory) {
            closestCategory =
              grossWt - currentCategory <= nextCategory - grossWt
                ? currentCategory
                : nextCategory;
            break;
          }
        }
      }
    }

    return closestCategory;
  }


  // Open popup with selected item
  const handleOpenPopup = (rowIndex, key, cindex) => {
    console.log("checking key stone ", key);
    if (key === "Stones") {
      setColumnIndex(cindex);
      setAddedProducts((prevProducts) =>
        prevProducts.map((item, i) =>
          i === rowIndex
            ? {
              ...item,
              Stones:
                item.Stones && item.Stones.length > 0
                  ? item.Stones // Keep existing Stones as they are
                  : [addStone], // Add addStone only if Stones is empty or undefined
            }
            : item
        )
      );
      // Access the latest products list after the update
      setAddedProducts((prevProducts) => {
        const selectedRow = prevProducts[rowIndex];
        if (selectedRow) {
          setSelectedRow(rowIndex); // Set the selected row
        }
        return prevProducts; // Maintain state integrity
      });

      setTimeout(() => {
        setPopupVisible("stones"); // Show the popup
      }, 0); // Defer the execution

      // setPopupVisible(true); // Show the popup
    }

    if (key === "DButton") {
      setColumnIndex(cindex);
      setAddedProducts((prevProducts) =>
        prevProducts.map((item, i) =>
          i === rowIndex
            ? {
              ...item,
              Stones:
                item.Stones && item.Stones.length > 0
                  ? item.Stones // Keep existing Stones as they are
                  : [addStone], // Add addStone only if Stones is empty or undefined
            }
            : item
        )
      );
      // Access the latest products list after the update
      setAddedProducts((prevProducts) => {
        const selectedRow = prevProducts[rowIndex];
        if (selectedRow) {
          setSelectedRow(rowIndex); // Set the selected row
        }
        return prevProducts; // Maintain state integrity
      });

      setTimeout(() => {
        setPopupVisible("stones"); // Show the popup
      }, 0); // Defer the execution

      // setPopupVisible(true); // Show the popup
    }
  };

  // Close the popup
  const handleClosePopup = () => {
    setPopupVisible("close"); // Hide the popup
    setSelectedRow(null); // Clear selected row
    // const nextElement = focusableRefs.current.gridSectionRefs[selectedRow * columnCount + columnIndex+1]; // Assuming you have a grid

    // console.log('check next element ', nextElement);

    // if (nextElement) {
    //   nextElement.focus();
    // }

    const gridRefs = focusableRefs.current.gridSectionRefs;

    if (gridRefs) {
      // Find the next focusable element that is not disabled or read-only
      const nextElement = gridRefs.find((element, index) => {
        return (
          index > selectedRow * columnCount + columnIndex && // Must be after the current element
          element && // Ensure the element exists
          !element.disabled && // Not disabled
          !element.readOnly // Not read-only
        );
      });

      console.log("Next enabled element:", nextElement);

      // Focus on the next enabled element if it exists
      if (nextElement) {
        nextElement.focus();
      }
    }
  };

  // Save data from the popup
  const handleSavePopupold = (updatedStoneDetails) => {
    // Update the selected row with new stone details
    const updatedProducts = [...AddedProducts];
    console.log("checking updated items ", updatedProducts);
    console.log("checking index  ", selectedRow);
    const totalswt = updatedStoneDetails.reduce(
      (total, stone) => total + (parseFloat(stone.StoneWeight) || 0),
      0
    );
    const totalamt = updatedStoneDetails.reduce(
      (total, stone) => total + (parseFloat(stone.StoneAmount) || 0),
      0
    );



    const nwt = updatedProducts[selectedRow].GrossWt - totalswt;
    updatedProducts[selectedRow].Stones = updatedStoneDetails; // Update stones array
    updatedProducts[selectedRow].TotalStoneWeight = totalswt;
    updatedProducts[selectedRow].TotalStoneAmount = totalamt;
    updatedProducts[selectedRow].NetWt = nwt;
    setAddedProducts(updatedProducts); // Update state
    console.log("checking added stones ", updatedStoneDetails);



    handleClosePopup(); // Close the popup
  };

  const handleSavePopup = (updatedDetails, type) => {
    // Clone the products array
    const updatedProducts = [...AddedProducts];
    console.log("Checking updated items: ", updatedProducts);
    console.log("Selected row index: ", selectedRow);
  
    // Calculate total weight and amount for the updated details
    const totalWeight = updatedDetails.reduce(
      (total, item) =>
        total + (parseFloat(item[type === "diamond" ? "DiamondWeight" : "StoneWeight"]) || 0),
      0
    );
    const totalAmount = updatedDetails.reduce(
      (total, item) =>
        total + (parseFloat(item[type === "diamond" ? "DiamondAmount" : "StoneAmount"]) || 0),
      0
    );
  
    // Get the other weight depending on type
    const otherWeight =
      type === "diamond"
        ? updatedProducts[selectedRow].TotalStoneWeight || 0
        : updatedProducts[selectedRow].TotalDiamondWeight || 0;
  
    // Calculate NetWt as GrossWt - (totalWeight + otherWeight)
    const netWeight = updatedProducts[selectedRow].GrossWt - (totalWeight + otherWeight);
  
    // Update the respective fields based on the type
    if (type === "diamond") {
      updatedProducts[selectedRow].Diamonds = updatedDetails;
      updatedProducts[selectedRow].TotalDiamondWeight = totalWeight;
      updatedProducts[selectedRow].TotalDiamondAmount = totalAmount;
    } else {
      updatedProducts[selectedRow].Stones = updatedDetails;
      updatedProducts[selectedRow].TotalStoneWeight = totalWeight;
      updatedProducts[selectedRow].TotalStoneAmount = totalAmount;
    }
  
    // Update NetWt for the product
    updatedProducts[selectedRow].NetWt = netWeight;
  
    // Update the state and close the popup
    setAddedProducts(updatedProducts);
    console.log(`Updated ${type === "diamond" ? "diamond" : "stone"} details: `, updatedDetails);
    handleClosePopup();
  };
  

  const handleNavigate = (to) => {
    navigate(`/${to}`); // Use a template literal without unnecessary quotes
  };

  const handleKeyDown = (event) => {
    const { key } = event;

    // Combine refs from all sections
    const allFocusableElements = [
      ...(focusableRefs.current.topSectionRefs || []),
      ...(focusableRefs.current.middleSectionRefs || []),
      ...(focusableRefs.current.gridSectionRefs || []),
    ];

    const currentIndex = allFocusableElements.findIndex(
      (ref) => ref === document.activeElement
    );

    console.log(topSectionEnabled);
    console.log("Top section refs:", focusableRefs.current.topSectionRefs);
    console.log(
      "Middle section refs:",
      focusableRefs.current.middleSectionRefs
    );
    console.log("Grid section refs:", focusableRefs.current.gridSectionRefs);

    console.log("checking all refs ", allFocusableElements);

    if (currentIndex !== -1) {
      if (key === "Enter") {
        const currentElement = allFocusableElements[currentIndex];

        console.log(
          "Reached the last field. Triggering...",
          currentIndex,
          "  ",
          allFocusableElements.length,
          "  ",
          currentElement
        );
        // if (currentIndex === allFocusableElements.length - 1) {
        //   event.preventDefault(); // Prevent the default beavior
        //   console.log("Reached the last field. Triggering handleAddItem...");
        //   // handleadditem(); // Call the function when on the last field
        //   return;
        // }

        // If the current element is a button
        if (currentElement.tagName === "BUTTON") {
          // Trigger the click only if it hasn't been handled yet
          if (!currentElement.dataset.enterHandled) {
            currentElement.click(); // Trigger the button's onClick event
            currentElement.dataset.enterHandled = "true"; // Mark as handled
          } else {
            console.log("check element type ", currentElement);
            // Move to the next field after the button
            // event.preventDefault();

            // delete currentElement.dataset.enterHandled;
            if (currentIndex === allFocusableElements.length - 1) {
              event.preventDefault(); // Prevent the default beavior
              console.log(
                "Reached the last field. Triggering handleAddItem..."
              );
              handleadditem(); // Call the function when on the last field
              // return;
              // delete currentElement.dataset.enterHandled; // Reset handling flag
              // moveToNextFocusableElement(currentIndex, allFocusableElements);
            }
          }
          return; // Exit early
        }

        event.preventDefault(); // Prevent default action for non-button elements

        if (currentIndex === allFocusableElements.length - 1) {
          event.preventDefault(); // Prevent the default beavior
          console.log("Reached the last field. Triggering handleAddItem...");
          handleadditem(); // Call the function when on the last field
          // return;
          // delete currentElement.dataset.enterHandled; // Reset handling flag
          // moveToNextFocusableElement(currentIndex, allFocusableElements);
        } else {
          // Move to the next field
          moveToNextFocusableElement(currentIndex, allFocusableElements);
        }
      } else if (key === "ArrowLeft") {
        event.preventDefault();
        // Find the previous focusable element
        moveToPreviousFocusableElement(currentIndex, allFocusableElements);
      }
    }
  };

  // Helper function to move to the next focusable element
  const moveToNextFocusableElement = (currentIndex, allFocusableElements) => {
    let nextIndex = currentIndex + 1;
    while (nextIndex < allFocusableElements.length) {
      const nextElement = allFocusableElements[nextIndex];
      if (nextElement && !nextElement.disabled && !nextElement.readOnly) {
        nextElement.focus();
        break;
      }
      nextIndex++;
    }
  };

  // Helper function to move to the previous focusable element
  const moveToPreviousFocusableElement = (
    currentIndex,
    allFocusableElements
  ) => {
    let prevIndex = currentIndex - 1;
    while (prevIndex >= 0) {
      const prevElement = allFocusableElements[prevIndex];
      if (prevElement && !prevElement.disabled && !prevElement.readOnly) {
        prevElement.focus();
        break;
      }
      prevIndex--;
    }
  };

  const handleadditem = () => {
    let createProduct = {};

    itemfields.forEach((item) => {
      if (item.key && item.place === "middle") {
        createProduct[item.key] = item.value || ""; // Assign key-value pairs dynamically
      }
    });
    const newProduct = {
      ...createProduct,
      Quantity: "1",
      ItemCode: "",
      BranchName: Branch,
      BranchId: "",
      VendorName: "",
      VendorId: "",
      SKU: "",
      SKUId: "",
      DesignId: "",
      DesignName: "",
      // CollectionId: '',
      CollectionNameSKU: "",
      PacketId: "",
      PacketName: "",
      BoxId: "",
      BoxName: "",
      Stones: [],
      WeightCategory: "",
      LotNumber: 0,
      TotalStoneWeight: 0,
      TotalStoneAmount: 0,
      TotalStonePieces: 0,
      TotalWeight: 0,
      NetWt: 0,
    };

    // Validation logic
    if (AddedProducts.length === 0) {
      // If no items exist, create the product
      setAddedProducts((prevProducts) => [...prevProducts, newProduct]);
      console.log("Added product:", newProduct);
    } else {
      // If items exist, validate all items in AddedProducts
      const isValid = AddedProducts.every(
        (product) =>
          product.DesignName &&
          product.DesignName.trim() !== "" &&
          product.GrossWt > 0
      );

      if (isValid) {
        // Validation passed, add the new product
        setAddedProducts((prevProducts) => [...prevProducts, newProduct]);
        console.log("Added product:", newProduct);

        setTimeout(() => {
          focusOnFirstField(AddedProducts.length);
        }, 0);

        // focusOnFirstField(AddedProducts.length);

        // setAddedProducts((prevProducts) => {
        //   const updatedProducts = [...prevProducts, newProduct];
        //   focusOnFirstField(updatedProducts.length - 1); // Focus on the first field of the new row
        //   return updatedProducts;
        // });
      } else {
        // Validation failed, show an error or warning
        alert(
          "All items must have a DesignName and GrossWt greater than 0 before adding a new item."
        );
        // return
      }
    }

    console.log("Added products:", AddedProducts);
  };

  // useEffect(() => {
  //   if (AddedProducts.length > 0) {
  //     focusOnFirstField(AddedProducts.length - 1);
  //   }
  // }, [AddedProducts])

  const focusOnFirstField = (rowIndex) => {
    const allFocusableElements = [
      ...(focusableRefs.current.topSectionRefs || []),
      ...(focusableRefs.current.middleSectionRefs || []),
      ...(focusableRefs.current.gridSectionRefs || []),
    ];
    console.log("allFocusableElements:", allFocusableElements);
    console.log("columnCount:", columnCount);
    console.log("rowIndex:", rowIndex);

    // Calculate first field
    const firstField = allFocusableElements[rowIndex * columnCount];
    console.log("firstField:", firstField);

    if (firstField) {
      firstField.focus();
    } else {
      console.log("Could not find the first field");
    }
  };

  const columnCount = itemfields.filter(
    (field) =>
      field.place === "grid" && field.visibility !== "Hidden" && field.IsVisible
  ).length;


  //new code

  useStockTypeEffect(StockType, itemfields, setItemfields, categoriesData, apifieldsControls, selectedcategory);


  const handledropdown = (key, e, place) => {
    const value = e.target.value;

    setItemfields((prevFields) => {
      const updatedFields = prevFields.map((field) => {
        if (field.key === key && field.place === place) {
          return {
            ...field,
            value: value,
          };
        }
        return field;
      });
      return updatedFields;
    });

    if (place === 'middle' && key === 'CategoryId') {

      setSelectedCategory(value)

    } if (place === 'top' && key === 'StockType') {

      setStockType(value)

    }

    if (place === 'top' && key === 'SKU') {

      setSkuValue(value)

    }

  }

  const inputselectchange = (key, e, place) => {
    const value = e.value;

    setItemfields((prevFields) => {
      const updatedFields = prevFields.map((field) => {
        if (field.key === key && field.place === place) {
          return {
            ...field,
            value: value,
          };
        }
        return field;
      });
      return updatedFields;
    });

    if (key === 'SKU' && place === 'top') {
      setSkuValue(value)
    }

  }

  const middlechange = (e, key, place) => {
    console.log('checking middle change ', e.target.value);
    const value = e.target.value;

    setItemfields((prevFields) => {
      const getFieldValue = (keyToFind) => {
        const field = prevFields.find(
          (f) => f.key === keyToFind && f.place === place
        );
        return parseFloat(field?.value || 0);
      };

      const updateField = (keyToUpdate, newValue) => {
        const fieldIndex = prevFields.findIndex(
          (f) => f.key === keyToUpdate && f.place === place
        );
        if (fieldIndex !== -1) {
          prevFields[fieldIndex] = {
            ...prevFields[fieldIndex],
            value: newValue,
          };
        }
      };

      const grossWt =
        key === "GrossWt" ? parseFloat(value || 0) : getFieldValue("GrossWt", 'middle');
      const stoneWt =
        key === "TotalStoneWeight"
          ? parseFloat(value || 0)
          : getFieldValue("TotalStoneWeight", 'middle');
      const packingWt =
        key === "PackingWeight"
          ? parseFloat(value || 0)
          : getFieldValue("PackingWeight", 'middle');
      let clipQty =
        key === "ClipQuantity"
          ? parseFloat(value || 0)
          : getFieldValue("ClipQuantity", 'middle');
      const clipWt =
        key === "ClipWeight"
          ? parseFloat(value || 0)
          : getFieldValue("ClipWeight", 'middle');
      const tweight =
        key === "TotalWeight"
          ? parseFloat(value || 0)
          : parseFloat(getFieldValue("TotalWeight", 'middle') || 0);
      clipQty = clipQty || 1
      const totalClipWt = clipQty * clipWt;

      if (
        [grossWt, stoneWt, packingWt, clipQty, clipWt].some((val) => isNaN(val))
      ) {
        alert("Error: Invalid input detected. Please provide numeric values.");
        return prevFields; // Skip updating if any value is invalid
      }
      console.log("checking total ", '  ', clipQty);

      updateField(key, value);

      // Update dependent fields
      if (key === "GrossWt") {
        const netWt = grossWt - stoneWt;
        const totalWeight = grossWt + packingWt;
        const tw = tweight > 0 ? totalWeight : 0;



        updateField("NetWt", netWt);
        updateField("TotalWeight", tw);
      } else if (key === "TotalStoneWeight") {
        const netWt = grossWt - stoneWt;
        updateField("NetWt", netWt);
      } else if (key === "PackingWeight") {
        console.log("checking packing weight ", packingWt, "   ", tweight);

        if (packingWt > tweight) {
          updateField("PackingWeight", 0);
        } else {
          if (packingWt > 0 && tweight > 0) {
            const g = tweight - packingWt;
            const n = g - stoneWt;

            updateField("GrossWt", g.toFixed(2));
            updateField("NetWt", n.toFixed(2));
          }

        }
      } else if (key === "ClipQuantity" || key === "ClipWeight") {



        const tpacking = totalClipWt;
        const tw = tpacking + grossWt;
        updateField("PackingWeight", totalClipWt);
        updateField("TotalWeight", tw);
        if (totalClipWt > 0) {
          // AddStockUtil.changeinputvisiblity({
          //   key, itemfields, setItemfields, visible: "ReadOnly",
          //   place: "middle"
          // })
          changeinputvisiblity(key, 'ReadOnly', 'middle')
        } else {
          // AddStockUtil.changeinputvisiblity({
          //   key, itemfields, setItemfields, visible: "ReadOnly",
          //   place: "middle"
          // })
          changeinputvisiblity(key, 'ReadOnly', 'middle')
        }

      } else if (key === "TotalWeight") {
        if (tweight > 0) {
          const t = tweight - packingWt;
          const n = t - stoneWt;

          updateField("GrossWt", t);
          updateField("NetWt", n);


        } else {
          updateField("PackingWeight", 0);
          updateField("GrossWt", 0);
          updateField("NetWt", 0);
          updateField("TotalWeight", 0);
        }
      }

      return [...prevFields]; // Return the updated fields array
    });

  }

  const changeinputvisiblity = (key, visible, place) => {
    setItemfields((prevFields) =>
      prevFields.map((field) => {
        return {
          ...field,
          visibility: 'ReadOnly'
        };
      })
    );
  };

  useEffect(() => {
    console.log("Itemfields updated in useEffect:", itemfields); // Observe updated state
  }, [itemfields]);


  const changeinputvisiblity11 = (key, visible, place) => {
    setItemfields((prevFields) => {
      const updatedFields = prevFields.map((field) => {
        if (
          (field.key === "PackingWeight" && field.place === 'middle')
        ) {
          return { ...field, visibility: 'ReadOnly', IsVisible: 'ReadOnly' }; // Create a new object
        }
        return field;
      });

      console.log("Updated fields:", updatedFields);
      return updatedFields; // Return the new array
    });
    console.log("After updating:", itemfields);
    // setItemfields((prevFields) => {
    //   const updatedFields = prevFields.map((field) => {
    //     if (
    //       (key === "PackingWeight" &&
    //         [
    //           "ClipQuantity",
    //           "ClipWeight",
    //           "OtherWeight",
    //           "PouchWeight",
    //           "TagWeight",
    //           "FindingWeight",
    //         ].includes(field.key) &&
    //         field.place === place) ||
    //       ([
    //         "ClipQuantity",
    //         "ClipWeight",
    //         "OtherWeight",
    //         "PouchWeight",
    //         "TagWeight",
    //         "FindingWeight",
    //       ].includes(key) &&
    //         field.key === "PackingWeight" &&
    //         field.place === place)
    //     ) {
    //       return { ...field, visibility: visible }; // Create a new object
    //     }
    //     return field;
    //   });

    //   console.log("Updated fields:", updatedFields); // Debugging log
    //   return updatedFields; // Return the new array
    // });
  };

  useEffect(() => {

    console.log('checking update ', itemfields);

  }, [itemfields])



  const changeinputvisiblity1 = (key, visible, place, index) => {
    if (key === "PackingWeight") {
      setItemfields((prevFields) =>
        prevFields.map((field) => {
          if (
            [
              "ClipQuantity",
              "ClipWeight",
              "OtherWeight",
              "PouchWeight",
              "TagWeight",
              "FindingWeight",
            ].includes(field.key) &&
            field.place === place
          ) {

            return {
              ...field,
              visibility: 'ReadOnly', // Ensure other fields in the grid remain editable
            };
          }
          return field;
        })
      );
    } else if (
      [
        "ClipQuantity",
        "ClipWeight",
        "OtherWeight",
        "PouchWeight",
        "TagWeight",
        "FindingWeight",
      ].includes(key)
    ) {
      setItemfields((prevFields) =>
        prevFields.map((field) => {
          if (field.key === "PackingWeight" && field.place === place) {
            return {
              ...field,
              visibility: 'ReadOnly', // Ensure PackingWeight remains editable in the grid
            };
          }
          return field;
        })
      );
    }
  }




  const handlegriddropdown = (key, e, rowIndex) => {

    const value = e.target.value;
    setAddedProducts((prevProducts) =>
      prevProducts.map((row, currentRowIndex) => {
        if (currentRowIndex !== rowIndex) return row;
        let updatedRow = { ...row };

        updatedRow[key] = value;



        return updatedRow;
      }))

  }

  const handlegridinput = (key, e, rowIndex) => {

    console.log('checking all keyatgrid ', key);
    const value = e.target.value;
    setAddedProducts((prevProducts) =>
      prevProducts.map((row, currentRowIndex) => {
        if (currentRowIndex !== rowIndex) return row;
        let updatedRow = { ...row };

        updatedRow[key] = value;

        if (
          [
            "GrossWt",
            "TotalStoneWeight",
            "PackingWeight",
            "ClipQuantity",
            "ClipWeight",
            "PackingWeight",
            "OtherWeight",
            "PouchWeight",
            "TagWeight",
            "FindingWeight",
            "LanyardWeight",
            "TotalWeight",
          ].includes(key)
        ) {
          const grossWt =
            key === "GrossWt"
              ? parseFloat(value)
              : parseFloat(row.GrossWt || 0);
          const stoneWt =
            key === "TotalStoneWeight"
              ? parseFloat(value)
              : parseFloat(row.TotalStoneWeight || 0);
          const packingWt =
            key === "PackingWeight"
              ? parseFloat(value)
              : parseFloat(row.PackingWeight || 0);
          const clipQty =
            key === "ClipQuantity"
              ? parseFloat(value)
              : parseFloat(row.ClipQuantity || 1);
          const clipWt =
            key === "ClipWeight"
              ? parseFloat(value)
              : parseFloat(row.ClipWeight || 0);
          const tweight =
            key === "TotalWeight"
              ? parseFloat(value)
              : parseFloat(row.TotalWeight || 0);
          const otherweight =
            key === "OtherWeight"
              ? parseFloat(value)
              : parseFloat(row.OtherWeight || 0);
          const pouchweight =
            key === "PouchWeight"
              ? parseFloat(value)
              : parseFloat(row.PouchWeight || 0);
          const tagweight =
            key === "TagWeight"
              ? parseFloat(value)
              : parseFloat(row.TagWeight || 0);
          const findweight =
            key === "FindingWeight"
              ? parseFloat(value)
              : parseFloat(row.FindingWeight || 0);
          const lanyweight =
            key === "LanyardWeight"
              ? parseFloat(value)
              : parseFloat(row.LanyardWeight || 0);

          if (value !== '') {
            if (
              [
                grossWt,
                stoneWt,
                packingWt,
                clipQty,
                clipWt,
                otherweight,
                pouchweight,
                tagweight,
                findweight,
              ].some((val) => isNaN(val))
            ) {
              alert(
                "Error: Invalid input detected. Please provide numeric values."
              );
              return row; // Skip updating this row if the input is invalid
            }
          }
          const totalClipWt = clipQty * clipWt;
          if (key === "GrossWt") {
            const n = grossWt - stoneWt;
            const tw = grossWt + packingWt;
            updatedRow = {
              ...updatedRow,
              // GrossWt: g.toFixed(2),
              NetWt: n.toFixed(2),
              TotalWeight: tweight > 0 ? tw : 0,
            };
          } else if (key === "TotalStoneWeight") {
            const n = grossWt - stoneWt;
            updatedRow = {
              ...updatedRow,
              // GrossWt: g.toFixed(2),
              NetWt: n.toFixed(2),
            };
          } else if (key === "PackingWeight") {
            if (packingWt > tweight) {
              updatedRow = {
                ...updatedRow,
                PackingWeight: 0, // Reset PackingWeight
              };

              // Replace alert with a user-friendly notification
              alert("Packing weight cannot be more than the total weight."); // Hypothetical function for showing errors

              console.error(
                "Invalid PackingWeight: Packing weight exceeds total weight."
              );

              // return; // Stop further execution
            } else {
              if (packingWt > 0 && tweight > 0) {
                const g = tweight - packingWt;
                const n = g - stoneWt;
                updatedRow = {
                  ...updatedRow,
                  GrossWt: g.toFixed(2),
                  NetWt: n.toFixed(2),
                };

                // handleVisibilityChange(key)
                handleVisibilityChange(key, "ReadOnly");
              }
            }
          } else if (key === "ClipQuantity") {
            // if(totalClipWt > 0){

            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;

            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");

            // }
          } else if (key === "ClipWeight") {
            if (totalClipWt > 0) {
              // handleVisibilityChange(key)
              const tpacking =
                totalClipWt +
                otherweight +
                pouchweight +
                tagweight +
                findweight +
                lanyweight;
              const tw = tpacking + grossWt;
              // handleVisibilityChange(key)
              updatedRow = {
                ...updatedRow,
                PackingWeight: tpacking,
                TotalWeight: tw,
              };
              handleVisibilityChange(key, "ReadOnly");
            }
          } else if (key === "TotalWeight") {
            if (tweight > 0) {
              const t = tweight - packingWt;
              const n = t - stoneWt;

              // const n = g - stoneWt;
              updatedRow = {
                ...updatedRow,
                // PackingWeight: 0,
                GrossWt: t,
                NetWt: n,
              };
            } else {
              updatedRow = {
                ...updatedRow,
                PackingWeight: 0,
                GrossWt: 0,
                NetWt: 0,
                TotalWeight: 0,
              };
            }

            // handleVisibilityChange(key, 'ReadOnly')
          } else if (key === "OtherWeight") {
            // if(otherweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else if (key === "PouchWeight") {
            // if(pouchweight > 0){
            console.log("checking packing weight  ", pouchweight);

            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }else{

            // }
          } else if (key === "TagWeight") {
            // if(tagweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else if (key === "FindingWeight") {
            // if(findweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else if (key === "LanyardWeight") {
            // if(lanyweight > 0){
            // handleVisibilityChange(key)
            const tpacking =
              totalClipWt +
              otherweight +
              pouchweight +
              tagweight +
              findweight +
              lanyweight;
            const tw = tpacking + grossWt;
            // handleVisibilityChange(key)
            updatedRow = {
              ...updatedRow,
              PackingWeight: tpacking,
              TotalWeight: tw,
            };
            handleVisibilityChange(key, "ReadOnly");
            // }
          } else {
          }


          if (["MakingPercentage", "WastagePercent"].includes(key)) {
            updatedRow.MakingPercentage = value;
            updatedRow.WastagePercent = value;
          }

        } else if (key === "RFIDCode") {
          const barcodeValue = value.toUpperCase();
          updatedRow.RFIDCode = barcodeValue;
          console.log('checking all items ', allLabelledStockData);


          const isBarcodeInUse = allLabelledStockData.some(
            (item) => item.RFIDCode === barcodeValue && item.Status !== "Sold"
          );

          if (isBarcodeInUse) {
            alert(
              `Barcode ${barcodeValue} is already in use for another product.`
            );
            updatedRow.RFIDCode = ""; // Clear RFIDCode if duplicate
          } else {
            const matchingProduct = rifdData?.find(
              (item) => item.BarcodeNumber === barcodeValue
            );
            updatedRow.TIDNumber = matchingProduct
              ? matchingProduct.TidValue
              : null;
          }
        }

        return updatedRow;
      }))

  }

  const productFilter = new ProductFilter(
    productTypeData,
    purityData,
    collectionTypeData,
    AddedProducts,
    getFieldValue
  );

  const filteredProducts = (place, rowIndex) => {
    const filtered = productFilter.filterProducts(place, rowIndex);
    console.log("Filtered Products:", filtered);
    return filtered;

  };

  const filteredPurity = (place, rowIndex) => {
    const filtered = productFilter.filterPurity(place, rowIndex);
    console.log("Filtered Purity:", filtered);
    return filtered;
  };

  const filteredDesigns = (place, rowIndex) => {
    const filtered = productFilter.filterDesigns(place, rowIndex);
    console.log("Filtered Designs:", filtered);
    return filtered;
  };

  const saveall = () => {
    const errors = [];

    console.log('check added products', AddedProducts);

    AddedProducts.forEach((product, index) => {
      const errorsForProduct = [];

      // Validate GrossWt
      if (!product.GrossWt || parseFloat(product.GrossWt) <= 0) {
        errorsForProduct.push(`Gross weight must be greater than 0.`);
      }

      // Validate DesignName
      if (!product.DesignName || product.DesignName.trim() === "") {
        errorsForProduct.push(`Design name is missing.`);
      }

      // Validate VendorId
      if (!product.VendorId) {
        errorsForProduct.push(`Vendor ID is missing.`);
      }

      // Validate VendorName
      if (!product.VendorName || product.VendorName.trim() === "") {
        errorsForProduct.push(`Vendor name is missing.`);
      }

      // If there are errors for this product, add them to the errors array
      if (errorsForProduct.length > 0) {
        errors.push(`Item ${index + 1}:\n- ${errorsForProduct.join("\n- ")}`);
      }
    });

    // If there are any errors, show an alert with detailed error messages
    if (errors.length > 0) {
      alert(`Please address the following issues:\n\n${errors.join("\n\n")}`);
      console.error("Validation errors:", errors);
      return;
    }

    console.log("All items are valid. Proceeding to save...");

    const updatedProducts = AddedProducts.map((product) => {
      let updatedProduct = { ...product };

      if (!product.WeightCategory) {
        const selectedSku = filteredsku.find(
          (v) => v.StockKeepingUnit === product.SKU
        );

        if (selectedSku && selectedSku.WeightCategories) {
          const weightCategoriesArray =
            selectedSku.WeightCategories.split(",").map(Number);

          const grossWt = parseFloat(product.GrossWt);
          const weightCategory = findClosestWeightCategory(
            grossWt,
            weightCategoriesArray
          );

          updatedProduct = {
            ...updatedProduct,
            WeightCategory: weightCategory || 0,
          };
        }
      }

      // Add required fields
      updatedProduct = {
        ...updatedProduct,
        ClientCode: clientCode,
        EmployeeId: employeedid,
        EmployeeCode: employeedid,
        CompanyId: 0,
        CounterId: 0,
        count: 0,
        MetalId: 1,
        WarehouseId: 0,
        TaxId: 0,
        // Diamonds: [],
        DeptId: 0,
      };

      // Remove unwanted keys
      const {
        dsleves,
        importbtn,
        mainstone,
        addbtn,
        images,
        FinePercent,
        WastagePercent,
        FineWastage,
        EmployeeId,
        count,
        TaxId,
        DeptId,
        ...cleanedProduct
      } = updatedProduct;

      return cleanedProduct;
    });

    console.log("Checking payload before sending:", updatedProducts);

    const payloadService = new PayLoadService();

    payloadService
      .sendPayload(updatedProducts)
      .then((response) => {
        console.log("API Response:", response);

        if (Array.isArray(response) && response.length > 0) {
          const processedIds = response.map((item) => item.Id).join(", ");
          GenerateLabel(response, labelFormat);
          setAddedProducts([]);
          setItemfields((prevFields) =>
            prevFields.map((field) => ({ ...field, value: "" }))
          );
          setSelectedCategory("");
          setStockType("");
        } else if (response.Message) {
          alert(`Message: ${response.Message}`);
        } else {
          alert("Operation completed successfully!");
        }
      })
      .catch((error) => {
        let errorDetails;
        try {
          errorDetails = JSON.parse(error.message);
        } catch {
          console.error("Unexpected error format:", error);
          alert("An unexpected error occurred. Please check the console.");
          return;
        }

        console.error("API Error Details:", errorDetails);

        let alertMessage = `Error: ${errorDetails.Title || "Unknown error occurred"}\nTrace ID: ${errorDetails.traceId || "N/A"}`;
        if (errorDetails.errors) {
          alertMessage += `\n\nValidation Errors:\n`;
          for (const [key, messages] of Object.entries(errorDetails.errors)) {
            alertMessage += `\nField: ${key}\n- ${messages.join("\n- ")}`;
          }
        }

        alert(alertMessage);
      });
  };



  const saveallold = () => {
    const allValid = AddedProducts.every((product) => {
      const grossWtValid = parseFloat(product.GrossWt) > 0;
      const designNameValid =
        product.DesignName && product.DesignName.trim() !== "";
      const vendorIdValid = product.VendorId;
      const vendorNameValid =
        product.VendorName && product.VendorName.trim() !== "";

      console.log(`GrossWt Valid: ${grossWtValid}`);
      console.log(`DesignName Valid: ${designNameValid}`);
      console.log(`VendorId Valid: ${vendorIdValid}`);
      console.log(`VendorName Valid: ${vendorNameValid}`);

      return (
        grossWtValid && designNameValid && vendorIdValid && vendorNameValid
      );
    });

    if (allValid) {
      console.log("All items have grosswt > 0. Proceeding to save...");

      const updatedProducts = AddedProducts.map((product) => {
        let updatedProduct = { ...product };

        if (!product.WeightCategory) {
          const selectedSku = filteredsku.find(
            (v) => v.StockKeepingUnit === product.SKU
          );

          if (selectedSku && selectedSku.WeightCategories) {
            const weightCategoriesArray =
              selectedSku.WeightCategories.split(",").map(Number);

            const grossWt = parseFloat(product.GrossWt);
            const weightCategory = findClosestWeightCategory(
              grossWt,
              weightCategoriesArray
            );

            updatedProduct = {
              ...updatedProduct,
              WeightCategory: weightCategory || 0,
            };
          }
        }

        // Add required fields
        updatedProduct = {
          ...updatedProduct,
          ClientCode: clientCode,
          EmployeeId: employeedid,
          EmployeeCode: employeedid,
          CompanyId: 0,
          CounterId: 0,
          count: 0,
          MetalId: 1,
          WarehouseId: 0,
          TaxId: 0,
          // Stones: [],
          // Diamonds: [],
          DeptId: 0,
        };

        // Remove unwanted keys
        const {
          dsleves,
          importbtn,
          mainstone,
          addbtn,
          images,

          FinePercent,
          WastagePercent,
          FineWastage,

          EmployeeId,
          count,
          TaxId,
          DeptId,
          ...cleanedProduct
        } = updatedProduct;

        return cleanedProduct;
      });

      console.log("checking payload before ", updatedProducts);

      const payloadService = new PayLoadService();

      payloadService
        .sendPayload(updatedProducts)
        .then((response) => {
          console.log("API Response:", response);
          // Handle the response as needed (e.g., show success message)

          if (Array.isArray(response) && response.length > 0) {
            // Example: Show the IDs of the processed items in an alert
            const processedIds = response.map((item) => item.Id).join(", ");
            // alert(`Operation completed successfully! Processed item IDs: ${processedIds}`);

            GenerateLabel(response, labelFormat);

            setAddedProducts([]);


            const updatedFields = localfields.map((localField) => {
              const matchingApiField = apifieldsControls.find(
                (apiField) =>
                  apiField.key === localField.key && apiField.place === localField.place
              );
              if (matchingApiField) {
                return {
                  ...localField,
                  label: matchingApiField.label,
                  placeholder: matchingApiField.placeholder,
                  priority: matchingApiField.priority,
                  type: localField.type,
                  visibility: matchingApiField.visibility,
                  place: matchingApiField.place,
                  value: "",
                };
              }
              return localField;
            });


            setItemfields((prevFields) =>
              prevFields.map((field) => ({
                ...field, // Spread the existing properties of the field
                value: "", // Set the value property to an empty string
              }))
            );
            setItemfields(updatedFields)
            setSelectedCategory('')
            setStockType('')

            //   setTimeout(() => {
            //     window.location.reload();
            // }, 30);
          } else if (response.Message) {
            // Handle cases where the response has a 'Message' field
            alert(`Message: ${response.Message}`);
          } else {
            // Generic success message for other cases
            alert("Operation completed successfully!");
          }
        })
        .catch((error) => {
          let errorDetails;

          try {
            // Parse the error message to extract details
            errorDetails = JSON.parse(error.message);
          } catch {
            console.error("Unexpected error format:", error);
            alert(
              "An unexpected error occurred. Please check the console for details."
            );
            return;
          }

          // Log the parsed error details
          console.error("API Error Details:", errorDetails);

          let alertMessage = `Error: ${errorDetails.Title || "Unknown error occurred"
            }\nTrace ID: ${errorDetails.traceId || "N/A"}`;

          // Include field-specific errors
          if (errorDetails.errors) {
            alertMessage += `\n\nValidation Errors:\n`;

            for (const [key, messages] of Object.entries(errorDetails.errors)) {
              alertMessage += `\nField: ${key}\n- ${messages.join("\n- ")}`;
            }
          }

          // Display the alert with all errors
          alert(alertMessage);
        });
    } else {
      console.error("Some items have grosswt <= 0. Please fix these items.");
      alert(
        "Please ensure all items have grosswt greater than 0 before saving."
      );
    }
  };


  const handlepopup = (key, place, rowIndex) => {



    if (place === 'bottom') {
      if (key === 'stones') {
        console.log('checking popupbtn before ', AddedProducts[rowIndex].Stones);
        if (AddedProducts[rowIndex].Stones && AddedProducts[rowIndex].Stones.length > 0) {
          // If Stones exists and is not empty, trigger popup
          setSelectedRow(rowIndex)
          setTimeout(() => {
            setPopupVisible('stones');
          }, 0);
        } else {

          // Otherwise, add a new stone to the item
          setAddedProducts((prevProducts) =>
            prevProducts.map((item, i) =>

              i === rowIndex
                ? {
                  ...item,
                  Stones:
                    item.Stones && item.Stones.length > 0
                      ? item.Stones // Keep existing Stones as they are
                      : [addStone], // Add addStone only if Stones is empty or undefined
                }
                : item
            )
          );
          setSelectedRow(rowIndex)
          setTimeout(() => {
            setPopupVisible('stones');
          }, 0);
          console.log('checking popupbtn ', AddedProducts);
        }
      }else if(key === 'diamond'){
        if (AddedProducts[rowIndex].Diamonds && AddedProducts[rowIndex].Diamonds.length > 0) {
          // If Stones exists and is not empty, trigger popup
          setSelectedRow(rowIndex)
          setTimeout(() => {
            setPopupVisible('diamonds');
          }, 0);
        } else {

          // Otherwise, add a new stone to the item
          setAddedProducts((prevProducts) =>
            prevProducts.map((item, i) =>

              i === rowIndex
                ? {
                  ...item,
                  Diamonds:
                    item.Diamonds && item.Diamonds.length > 0
                      ? item.Diamonds // Keep existing Stones as they are
                      : [addDiamond], // Add addStone only if Stones is empty or undefined
                }
                : item
            )
          );
          setSelectedRow(rowIndex)
          setTimeout(() => {
            setPopupVisible('diamonds');
          }, 0);
          console.log('checking popupbtn ', AddedProducts);
        }
      }
    }

  }



  return (
    <div>
      <div>
        <AdminHeading />

        {loading ? (
          // Show spinner while loading
          <div className={style.spinnercontainer}>
            <ClipLoader size={50} color={"#123abc"} loading={loading} />
            <p>Loading data...</p>
          </div>
        ) : (
          <div>
            <ErrorModal
              isOpen={showModal}
              onRequestClose={() => {
                setShowModal(false); // Close the modal
                navigate("/adminhome"); // Redirect to /adminhome
              }}
              onReload={reloadData} // Pass reload function
              message={errorMessage}
            />

            <div className={style.adminMainBodyBox} id="addBulkProductsBoxTop">
              <AdminBreadCrump
                title={"Add Bulk Stock"}
                companyName={"Loyalstring"}
                module={"E-commerce"}
                page={"Add Bulk Stock"}
              />
              <div className={style.adminAddCategoryMainBox2stock}>
                <div className={style.adminAddCategoryMainBox2inner}>
                  <div
                    className={style.adminAddCategoryMainBox2inner2}
                    onKeyDown={handleKeyDown}
                  >




                    {popupVisible && popupVisible === "stones" && (
                      <SingleStonePopUp
                        itemlist={AddedProducts}
                        addStone={addStone}
                        index={selectedRow}
                        onClose={handleClosePopup}
                        onSave={handleSavePopup}
                        stonemaster={stonemaster}
                      />
                    )}

                    {popupVisible && popupVisible === "diamonds" && (
                      <SingleDiamondPopup
                        itemlist={AddedProducts}
                        addStone={addDiamond}
                        index={selectedRow}
                        onClose={handleClosePopup}
                        onSave={handleSavePopup}
                        allDiamondAttributes={allDiamondAttributes}
                      />
                    )}

                    {/* <RFIDPopup
                    allLabelledStockData={allLabelledStockData}
                    AddedProducts={AddedProducts}
                    rifdData={rifdData}
                      isOpen={popupData.isOpen}
                      pieces={popupData.pieces}
                      initialRFIDs={popupData.initialRFIDs}
                      initialTIDs={popupData.initialTIDs}
                      onClose={() => setPopupData({ ...popupData, isOpen: false })}
                      onSave={handlePopupSave}
                    /> */}

                    {topSectionEnabled && (
                      <div className={style.adminAddCategoryMainBox2fieldbox}>

                        <AddStockTopSection
                          fields={itemfields}
                          handledropdown={handledropdown}
                          inputselectchange={inputselectchange}
                          filteredSupplier={filteredSupplier}
                          filteredlot={filteredlot}
                          filteredsku={filteredsku}
                          branchOption={branchOption}


                        />

                      </div>


                    )}
                    {middleSectionEnabled && (
                      <div>
                        <div
                          className={
                            style.adminAddCategoryMainBox2sectionHeader
                          }
                        >
                          <p className={style.adminAddCategoryMainBoxheader}>
                            Item Details
                          </p>
                        </div>
                        <div className={style.adminAddCategoryMainBox2itembox}>

                          <AddStockMiddleSection
                            fields={itemfields}
                            categoriesData={categoriesData}
                            filteredProducts={filteredProducts}
                            handledropdown={handledropdown}
                            filteredDesigns={filteredDesigns}
                            filteredPurity={filteredPurity}
                            collectionmainlist={collectionmainlist}
                            allPacketNumbers={allPacketNumbers}
                            boxData={boxData}
                            allSku={allSku}
                            middlechange={middlechange}
                            selectedImages2={selectedImages2}

                          />

                          <div style={{ marginTop: "0px", width: "100%" }}>
                            <div
                              className={
                                style.adminAddCategoryMainBox2itemrowslast
                              }
                            >
                              <div className={style.buttonbox}>
                                <button
                                  onClick={handleCreateAddedProducts}
                                  className={style.custombtn}
                                  style={{ width: "20%" }}
                                >
                                  {" "}
                                  <Icon
                                    style={{ fontSize: "24px" }}
                                    icon="fluent:add-32-filled"
                                  />
                                  Add
                                </button>
                                <button className={style.custombtnreset}>
                                  {" "}
                                  <Icon
                                    style={{ fontSize: "24px" }}
                                    icon="ix:reset"
                                  />
                                  Reset
                                </button>

                                <button className={style.custombtn}>
                                  {" "}
                                  <Icon
                                    style={{ fontSize: "24px" }}
                                    icon="material-symbols:download"
                                  />
                                  Import
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div
                      className={style.adminAddCategoryMainBox2sectionHeader}
                    >
                      <p className={style.adminAddCategoryMainBoxheader}>
                        Added Items
                      </p>
                    </div>

                    <div
                      style={{ marginTop: "0px" }}
                      className={style.tablecontainer}
                    >
                      <AddStockGridSection
                        fields={itemfields}
                        categoriesData={categoriesData}
                        filteredProducts={filteredProducts}
                        handlegriddropdown={handlegriddropdown}
                        filteredDesigns={filteredDesigns}
                        filteredPurity={filteredPurity}
                        collectionmainlist={collectionmainlist}
                        allPacketNumbers={allPacketNumbers}
                        boxData={boxData}
                        allSku={allSku}
                        handlegridinput={handlegridinput}
                        selectedImages2={selectedImages2}
                        AddedProducts={AddedProducts}
                        handleadditem={handleadditem}
                        filteredSupplier={filteredSupplier}
                        filteredsku = {filteredsku}
                        setPopupVisible={setPopupVisible}
                        handlepopup={handlepopup}

                      />

                    </div>

                    <div
                      className={
                        style.adminAddCategoryMainBox2sectionHeaderlast
                      }
                    >
                      <div className={style.buttonbox2}>
                        <button
                          className={style.custombtn}
                          style={{ width: "24%" }}
                          onClick={saveall}
                        >
                          {" "}
                          <Icon
                            style={{ fontSize: "24px" }}
                            icon="ic:outline-check"
                          />
                          Save All
                        </button>
                        <button
                          style={{
                            backgroundColor: "#fff",
                            color: "#0077d4",
                            border: "1px solid #0077d4",
                          }}
                          className={style.custombtnreset}
                        >
                          {" "}
                          <Icon
                            style={{ fontSize: "24px", color: "#0077d4" }}
                          />
                          Reset
                        </button>
                        <button
                          className={style.custombtn}
                          style={{ width: "32%" }}
                          onClick={() => handleNavigate("inventory")} // Use an arrow function to pass the parameter
                        >
                          {" "}
                          <Icon
                            style={{ fontSize: "24px" }}
                            icon="solar:list-bold"
                          />
                          Labelled List
                        </button>

                        <button
                          style={{ width: "32%" }}
                          className={style.custombtn}
                        >
                          {" "}
                          <Icon
                            style={{ fontSize: "24px" }}
                            icon="solar:list-bold"
                          />
                          Unlabelled List
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}